import React, { useEffect, useState, useRef } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { v4 as uuid } from "uuid";
import "./courseContent.css"
import { deleteModuleContent, fetchCourseModuleList, fetchModuleContent, updateModuleContent, updateModules } from '../../../service/module';
import apiFunctions from '../../../service/axiosConfig/apiFunctions';
import { baseUrl } from '../../../constants';
import Modal from 'react-modal';
import CustomToast from '../../Toast';
import Loader from '../../layouts/loader';
import 'react-image-crop/dist/ReactCrop.css';
//import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
// added comment
// MyUploadAdapter.js
class MyUploadAdapter {
    constructor(loader, onFileUpload) {
        this.loader = loader;
        this.onFileUpload = onFileUpload;
    }
    upload() {
        return this.loader.file
            .then((file) => {
                // Implement your file upload logic here
                // For demonstration purposes, log the file name and size
                // Call the function passed to the constructor
                this.onFileUpload(file);

                return new Promise((resolve, reject) => {
                    resolve({ file });
                });
            })
            .catch((error) => {
                console.error('Error uploading file:', error);
                CustomToast.error('Error uploading file');
                return Promise.reject('Error uploading file');
            });
    }
}

const CourseContent = (props) => {
    const [show, setShow] = useState(false);
    const [isModuleInputVisible, setIsModuleInputVisible] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [insightModalIsOpen, setInsightModalIsOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isSubModuleInputVisible, setIsSubModuleInputVisible] = useState(false);
    const [submoduleName, setSubmoduleName] = useState('');
    const [maduleName, setModuleName] = useState('');
    const [maduleEditName, seteditModuleName] = useState('');
    const [maduleList, setModuleList] = useState([]);
    const [selectedSubModule, setSelectedSubModule] = useState('')
    const [selectedEditModule, setselectedEditModule] = useState({})
    const [selectedModuleId, setSelectedModuleId] = useState('')
    const [selectedModule, setSelectedModule] = useState({})
    const [courseContent, setcourseContent] = useState('')
    const [file_path, setFile_path] = useState('')
    const [selectedContentType, setSelectedContentType] = useState('')
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [selectedVFile, setSelectedVFile] = useState(null);
    const [previewVUrl, setPreviewVUrl] = useState(null);
    const [trance, setTrance] = useState(null);
    const [url, setUrl] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [maxAttempt, setMaxAttempt] = useState(1);
    const [passingPercentages, setPassingPercentages] = useState(0);
    const [testType, setTestType] = useState('base_line');
    const [contentType, setcontentType] = useState('general');
    const [isEligible, setIsEligible] = useState(false);
    const [courseID, setCourseId] = useState('')
    const [tags, setTags] = useState('')
    const [tagsQuestion, setQuestionTags] = useState('')
    const [data, setData] = useState([]);
    const [subModules, setSubModules] = useState(data?.sub_modules || []);
    const [moduleSubModulesMap, setModuleSubModulesMap] = useState({});
    const [loader, setLoader] = useState(false);
    const [courseName, setCourseName] = useState('')
    const [carouselUrl, setCarouselUrl] = useState(null);
    const [documentUrl, setDocumentUrl] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    // const [courseContent, setCourseContent] = useState('');
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [fileInput, setFileInput] = useState(null);
    const [selectedCarouselFiles, setSelectedCarouselFiles] = useState([]);
    const [uploadedCarouselUrls, setUploadedCarouselUrls] = useState([]);

    const [selectedDocuments, setSelectedDocuments] = useState([]);
    const [uploadedDocumentUrls, setUploadedDocumentUrls] = useState(null);
    const [isDocumentChecked, setIsDocumentChecked] = useState(false);
    const [uploadedDocumentUrl, setUploadedDocumentUrl] = useState(null);
    const carouselFilesInputRef = useRef(null);
    const documentFileInputRef = useRef(null);

    // Utility function to ensure proper sequential ranking for all questions
    const reRankAllQuestions = (forms) => {
        return forms.map((form, index) => ({
            ...form,
            rank: index + 1
        }));
    };

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const [markerForms, setMarkerForms] = useState([
        {
            video_marking: '',
            question_type: 'single_choice',
            ans_view: 'show_ans',
            content: '',
            options: [{}],
            correctAnswer: '',
            crt_ans_exp: '',
            wrng_ans_exp: '',
            sub_questions: [{
                video_marking: '',
                question_type: 'single_choice',
                ans_view: 'show_ans',
                content: '',
                options: [{}],
                correctAnswer: '',
                crt_ans_exp: '',
                wrng_ans_exp: '',
                marks: 1,
                rank: 1
            }],
            rating: { min: 0, max: 0, rating: 0 },
            marks: 1,
            rank: 1,
            question_tag: ''
        },
    ]);

    const handleAddMarkerForm = (i) => {
        const newRank = markerForms.length + 1; // Calculate the next sequential rank
        const newForm = {
            tempId: Date.now() + Math.random(), // Add unique temporary ID for new forms
            video_marking: '',
            question_type: 'single_choice',
            ans_view: 'show_ans',
            content: '',
            options: [{}],
            correctAnswer: '',
            crt_ans_exp: '',
            wrng_ans_exp: '',
            sub_questions: [{
                video_marking: '',
                question_type: 'single_choice',
                ans_view: 'show_ans',
                content: '',
                options: [{}],
                correctAnswer: '',
                crt_ans_exp: '',
                wrng_ans_exp: '',
                marks: 1,
                rank: 1
            }],
            rating: { min: 0, max: 0, ans: 0 },
            marks: 1,
            rank: newRank,
        };

        const updatedForms = [...markerForms, newForm];

        // Re-rank all forms to ensure sequential ranking
        const reRankedForms = reRankAllQuestions(updatedForms);

        setMarkerForms(reRankedForms);

        // submitForm()
    };

    const handleSubAddMarkerForm = (i, formIndex) => {
        const updatedForms = [...markerForms];
        const newRank = updatedForms[i].sub_questions.length + 1; // Calculate the next sequential rank
        updatedForms[i].sub_questions.push({
            video_marking: '',
            question_type: 'single_choice',
            ans_view: 'show_ans',
            content: '',
            options: [{}],
            correctAnswer: '',
            crt_ans_exp: '',
            wrng_ans_exp: '',
            marks: 1,
            rank: newRank
        })
        setMarkerForms(updatedForms);
    };

    const handleEditorChange = (event, editor, index) => {
        try {
            if (!editor || typeof index !== 'number' || !markerForms[index]) return;
            const updatedForms = [...markerForms];
            updatedForms[index].content = editor.getData();
            setMarkerForms(updatedForms);
        } catch (error) {
            handleEditorError(error);
        }
    };

    const handleSubEditorChange = (event, editor, index, formIndex) => {
        try {
            if (!editor || typeof index !== 'number' || typeof formIndex !== 'number' ||
                !markerForms[index] || !markerForms[index].sub_questions[formIndex]) return;
            const updatedForms = [...markerForms];
            updatedForms[index].sub_questions[formIndex].content = editor.getData();
            setMarkerForms(updatedForms);
        } catch (error) {
            handleEditorError(error);
        }
    };

    const handleTranceEditorChange = (event, editor) => {
        try {
            if (!editor) return;
            let data = editor?.getData();
            setTrance(data);
        } catch (error) {
            handleEditorError(error);
        }
    };

    const handleOptionChange = (optionIndex, event, formIndex) => {
        const updatedForms = [...markerForms];
        const unique_id = uuid();
        updatedForms[formIndex].options[optionIndex].content = event.target.value;
        updatedForms[formIndex].options[optionIndex].id = formIndex
        updatedForms[formIndex].options[optionIndex].is_correct = event.target.value === updatedForms[formIndex].correctAnswer
        setMarkerForms(updatedForms);
    };

    const handleAddOption = (formIndex) => {
        const updatedForms = [...markerForms];
        updatedForms[formIndex].options.push({});
        setMarkerForms(updatedForms);
    };

    const handleRemoveOption = (formIndex, optionIndex) => {
        const updatedForms = [...markerForms];
        updatedForms[formIndex].options.splice(optionIndex, 1);
        setMarkerForms(updatedForms);
    };

    const handleParaAddOption = (formIndex, index) => {
        const updatedForms = [...markerForms];
        updatedForms[formIndex].sub_questions[index].options.push({});
        setMarkerForms(updatedForms);
    };

    const handleParaRemoveOption = (formIndex, suboptionIndex, index) => {
        const updatedForms = [...markerForms];
        updatedForms[formIndex].sub_questions[index].options.splice(suboptionIndex, 1);
        setMarkerForms(updatedForms);
    };

    // const handleCorrectAnswerChange = (event, formIndex) => {
    //     const updatedForms = [...markerForms];
    //     updatedForms[formIndex].correctAnswer = event.target.value;
    //     setMarkerForms(updatedForms);
    // };

    const handleminChange = (event, formIndex) => {
        const updatedForms = [...markerForms];
        updatedForms[formIndex].rating.min = event.target.value;
        setMarkerForms(updatedForms);
    };

    const handlemaxChange = (event, formIndex) => {
        const updatedForms = [...markerForms];
        updatedForms[formIndex].rating.max = event.target.value;
        setMarkerForms(updatedForms);
    };

    const handleintervalChange = (event, formIndex) => {
        const updatedForms = [...markerForms];
        updatedForms[formIndex].rating.interval = event.target.value;
        setMarkerForms(updatedForms);
    };

    const handleansChange = (event, formIndex) => {
        const updatedForms = [...markerForms];
        updatedForms[formIndex].rating.ans = event.target.value;
        setMarkerForms(updatedForms);
    };

    const openEditModal = (data) => {
        seteditModuleName(data.title)
        setselectedEditModule(data)
        setIsEditModalOpen(true);
    };

    const closeEditModal = () => {
        setIsEditModalOpen(false);
    };

    const openDeleteModal = (data) => {
        setselectedEditModule(data)
        setIsDeleteModalOpen(true);
    };

    const closeDeleteModal = () => {
        setIsDeleteModalOpen(false);
    };

    const handleAddModuleClick = () => {
        setIsModuleInputVisible(true);
    };

    const handleAddSubModuleClick = (id) => {
        setSelectedSubModule(id)
        setIsSubModuleInputVisible(true);
    };

    const updateModule = (event, submoduleId, index) => {
        if (event.key === 'Enter') {
            const unique_id = uuid();
            if (submoduleId) {
                // Find the parent module to get its existing submodules
                const parentModule = maduleList.find(module => module.common_module_id === selectedSubModule);
                
                // Calculate proper rank for submodule based on existing submodules for this parent
                let newRank = 1;
                if (parentModule && parentModule.sub_modules && parentModule.sub_modules.length > 0) {
                    const existingRanks = parentModule.sub_modules.map(sub => sub.rank || 0);
                    newRank = Math.max(...existingRanks) + 1;
                }
                
                let data = {
                    addedModules: [
                        {
                            title: submoduleName,
                            common_module_id: unique_id,
                            rank: newRank,
                            parent_module_id: selectedSubModule
                        }
                    ],
                    course_meta_id: sessionStorage.getItem('courseId')
                }
                updateModules(data).then(() => {
                    getCourseModuleList()
                    setIsSubModuleInputVisible(false)
                    setIsModuleInputVisible(false)
                    setModuleName('')
                    setSubmoduleName('')

                })
            }
            else {
                // Calculate proper rank for main module
                let newRank = 1;
                if (maduleList && maduleList.length > 0) {
                    const existingRanks = maduleList.map(m => m.rank || 0);
                    newRank = Math.max(...existingRanks) + 1;
                }
                
                let data = {
                    addedModules: [
                        {
                            title: maduleName,
                            common_module_id: unique_id,
                            rank: newRank,
                        }
                    ],
                    course_meta_id: sessionStorage.getItem('courseId')
                }
                updateModules(data).then(() => {
                    getCourseModuleList()
                    setIsModuleInputVisible(false)
                    setIsSubModuleInputVisible(false)
                    setModuleName('')
                    setSubmoduleName('')
                })
            }
        }
    }

    const editModule = () => {
        let data = {
            editedModules: [
                {
                    title: maduleEditName,
                    _id: selectedEditModule._id,
                }
            ],
            course_meta_id: selectedEditModule.course_meta_id
        }
        updateModules(data).then((data) => {
            getCourseModuleList()
            CustomToast.success("Content saved successfully")
        }).catch((error) => {
            CustomToast.error("Error while save content")
        })
    }

    const DeleteModule = () => {
        deleteModuleContent(selectedEditModule.common_module_id).then((data) => {
            getCourseModuleList()
            CustomToast.success("Module deleted successfully")
        }).catch((error) => {
            CustomToast.error("Error while delete module")
        })
    }

    const getCourseModuleList = async () => {
        try {
            const course = await fetchCourseModuleList(sessionStorage.getItem('courseId'));
            if (course.status) {
                setModuleList(course.data);
                const updatedModuleSubModulesMap = {};
                course.data.forEach(module => {
                    updatedModuleSubModulesMap[module._id] = module.sub_modules;
                });
                setModuleSubModulesMap(updatedModuleSubModulesMap);

            } else {
                console.error("Error fetching courses:", course.error);
                CustomToast.error('Error while fetching courses')
            }
        } catch (error) {
            console.error("An unexpected error occurred:", error);
            CustomToast.error(error)
        }
    }

    useEffect(() => {
        //    let selectedModuleId = sessionStorage.getItem("selectedModuleId");
        //    console.log("selectedModule......", selectedModule)
        //    getModuleContent(selectedModuleId);

        const intervalId = setInterval(() => {
            const newCourseDetail = sessionStorage.getItem("courseId");
            let courseName = sessionStorage.getItem("courseName")
            setCourseName(courseName)

            if (JSON.stringify(newCourseDetail) !== JSON.stringify(courseID)) {
                getCourseModuleList()
                setCourseId(newCourseDetail)
            }
        }, 1000);
        return () => clearInterval(intervalId);
    }, [courseID]);

    useEffect(() => {
        const storedModuleId = sessionStorage.getItem("selectedModuleId");

        if (maduleList && maduleList.length > 0) {
            let savedModule = null;

            // Restore selected module from sessionStorage
            if (storedModuleId) {
                for (let module of maduleList) {
                    if (module._id === storedModuleId) {
                        savedModule = module;
                        break;
                    }

                    for (let sub of module.sub_modules || []) {
                        if (sub._id === storedModuleId) {
                            savedModule = sub;
                            break;
                        }

                        for (let subsub of sub.sub_sub_module || []) {
                            if (subsub._id === storedModuleId) {
                                savedModule = subsub;
                                break;
                            }
                        }

                        if (savedModule) break;
                    }

                    if (savedModule) break;
                }
            }

            // Pick the first module by default
            if (!savedModule) {

                const first = maduleList[0];

                if (first?.sub_modules?.[0]?.sub_sub_module?.[0]) {
                    savedModule = first.sub_modules[0].sub_sub_module[0];
                } else if (first?.sub_modules?.[0]) {
                    savedModule = first.sub_modules[0];
                } else {
                    savedModule = first;
                }
                sessionStorage.setItem("selectedModuleId", savedModule._id);
            }

            if (savedModule) {
                setSelectedModule(savedModule);
                getModuleContent(savedModule);
            }
        }
    }, [maduleList]);

    // useEffect(() => {
    //     getCourseModuleList()
    //     let courseName = sessionStorage.getItem("courseName")
    //     setCourseName(courseName)
    // }, [])
    const editorConfiguration = {
        // plugins: [ Essentials, Bold, Italic, Paragraph ],
        disabled: true,
        toolbar: []
    };

    const handleEditorError = (error) => {
        console.error('CKEditor error:', error);
        // Prevent the error from breaking the application
    };

    // Safe editor initialization function
    const setupUploadAdapter = (editor, fieldName) => {
        try {
            if (editor && editor.plugins && editor.plugins.get) {
                const fileRepository = editor.plugins.get('FileRepository');
                if (fileRepository) {
                    fileRepository.createUploadAdapter = (loader) => {
                        return new MyUploadAdapter(loader, (e) => handleImageUpload(e, fieldName));
                    };
                }
            }
        } catch (error) {
            handleEditorError(error);
        }
    };

    const submitForm = async (type) => {

        // Validation for test and video content types with questions
        if (selectedContentType === 'test' || selectedContentType === 'video') {
            // For test content, questions are mandatory
            // For video content, questions are optional - only validate if questions exist
            const shouldValidateQuestions = selectedContentType === 'test' ||
                (selectedContentType === 'video' && markerForms.length > 0 && markerForms.some(form => form.content && form.content.trim() !== ''));

            if (shouldValidateQuestions) {
                for (let i = 0; i < markerForms.length; i++) {
                    const form = markerForms[i];

                    // Skip validation for empty forms in video content
                    if (selectedContentType === 'video' && (!form.content || form.content.trim() === '')) {
                        continue;
                    }

                    // Validate question content
                    if (!form.content || form.content.trim() === '') {
                        CustomToast.error(`Please add content for question ${i + 1}.`);
                        return;
                    }

                    // Validate video marking for video content type (only for non-para questions) 
                    if (selectedContentType === 'video' && form.question_type !== 'para' && (!form.video_marking || form.video_marking.trim() === '')) { 
                        CustomToast.error(`Please add video marker time for question ${i + 1}.`); 
                        return; 
                    } 
 
                    // Validate marks for para type questions in video content 
                    if (selectedContentType === 'video' && form.question_type === 'para' && (!form.marks || form.marks.trim() === '')) { 
                        CustomToast.error(`Please add marks for question ${i + 1}.`); 
                        return; 
                    }

                    // Validate single choice and multi choice questions
                    if (form.question_type === 'single_choice' || form.question_type === 'multi_choice') {
                        // Check if options exist and have content
                        if (!form.options || form.options.length === 0) {
                            CustomToast.error(`Please add options for question ${i + 1}.`);
                            return;
                        }

                        // Check if all options have content
                        const emptyOptionIndex = form.options.findIndex(option => !option.content || option.content.trim() === '');
                        if (emptyOptionIndex !== -1) {
                            CustomToast.error(`Please add content for option ${emptyOptionIndex + 1} in question ${i + 1}.`);
                            return;
                        }

                        // Check if at least one option is marked as correct
                        const hasCorrectAnswer = form.options.some(option => option.is_correct === true);
                        if (!hasCorrectAnswer) {
                            CustomToast.error(`Please select at least one correct answer for question ${i + 1}.`);
                            return;
                        }
                    }

                    // Validate rating questions
                    if (form.question_type === 'rating') {
                        if (!form.rating || !form.rating.min || !form.rating.max || !form.rating.ans) {
                            CustomToast.error(`Please fill all rating fields for question ${i + 1}.`);
                            return;
                        }
                    }

                    // Validate paragraph questions with sub-questions
                    if (form.question_type === 'para' && form.sub_questions) {
                        for (let j = 0; j < form.sub_questions.length; j++) {
                            const subQuestion = form.sub_questions[j];

                            // Validate sub-question content
                            if (!subQuestion.content || subQuestion.content.trim() === '') {
                                CustomToast.error(`Please add content for sub-question ${j + 1} in question ${i + 1}.`);
                                return;
                            }

                            // Validate marks for sub-questions in video content type 
                            if (selectedContentType === 'video' && (!subQuestion.marks || subQuestion.marks.trim() === '')) { 
                                CustomToast.error(`Please add marks for sub-question ${j + 1} in question ${i + 1}.`); 
                                return; 
                            }

                            // Validate sub-question options if it's single/multi choice
                            if (subQuestion.question_type === 'single_choice' || subQuestion.question_type === 'multi_choice') {
                                if (!subQuestion.options || subQuestion.options.length === 0) {
                                    CustomToast.error(`Please add options for sub-question ${j + 1} in question ${i + 1}.`);
                                    return;
                                }

                                const emptySubOptionIndex = subQuestion.options.findIndex(option => !option.content || option.content.trim() === '');
                                if (emptySubOptionIndex !== -1) {
                                    CustomToast.error(`Please add content for option ${emptySubOptionIndex + 1} in sub-question ${j + 1} of question ${i + 1}.`);
                                    return;
                                }

                                const hasSubCorrectAnswer = subQuestion.options.some(option => option.is_correct === true);
                                if (!hasSubCorrectAnswer) {
                                    CustomToast.error(`Please select at least one correct answer for sub-question ${j + 1} in question ${i + 1}.`);
                                    return;
                                }
                            }
                        }
                    }
                }
            }
        }

        let data = {}
        switch (selectedContentType) {
            case 'content':
                data.type = selectedContentType;
                data.content = courseContent;
                data.content_type = contentType
                // data.url = file_path;
                break;
            case 'image':
                data.type = selectedContentType;
                data.url = file_path;
                break;
            case 'carousal':
                data.type = selectedContentType;
                data.content = courseContent;
                data.carousal_url = uploadedCarouselUrls;
                break;
            case 'document':
                data.type = selectedContentType;
                data.content = courseContent;
                data.document = uploadedDocumentUrls;
                data.downloadable = isDocumentChecked;
                break;
            case 'video':
                data.transcript = trance;
                data.type = selectedContentType;
                data.course_test_type = 'in_video';
                // Preserve existing video URL if no new file is uploaded
                if (file_path) {
                    data.url = file_path;
                } else if (url) {
                    data.url = url;
                }
                data.addedQuestions = markerForms;
                break;
            case 'test':
                data.content = courseContent;
                data.type = selectedContentType;
                data.addedQuestions = markerForms;
                data.max_attempts = maxAttempt;
                data.passing_percent = passingPercentages;
                data.test_skipable = false;
                data.course_test_type = testType;
                data.test_tag = tags
                break;

            // default:
            //   componentToRender = <DefaultComponent />;
        }
        // if (selectedContentType == "test") {
        //     console.log("fdsvcd");
        //     if (!data.max_attempts
        //         || !data.passing_percent) {
        //         CustomToast.error('Please fill required fields.');
        //         return
        //     }
        // }
        await updateModuleContent(type, selectedModule._id, data)
        setTimeout(() => {
            window.location.reload(true);
        }, 1000);
        getModuleContent(selectedModule)
    }
    window.submitForm = submitForm;

    const deleteSection = async (marker) => {
        // If marker has qid, it's saved - delete from server
        if (marker?.qid) {
            let data = {
                deletedQuestions: [marker.qid]
            }
            updateModuleContent('', selectedModule._id, data).then(() => {
                // Also update local state immediately to provide instant feedback
                const updatedForms = markerForms.filter(form => form !== marker);
                const reRankedForms = reRankAllQuestions(updatedForms);
                setMarkerForms(reRankedForms);

                // Then refresh from server to ensure consistency
                getModuleContent(selectedModule);
                CustomToast.success("Section deleted successfully");
            })
        } else {
            // If marker doesn't have qid, it's unsaved - remove from state and update ranks
            const updatedForms = markerForms.filter(form => form !== marker);

            // Re-rank ALL remaining forms (both saved and unsaved) to ensure sequential ranking
            const reRankedForms = reRankAllQuestions(updatedForms);

            setMarkerForms(reRankedForms);
            CustomToast.success("Section deleted successfully");
        }
    }

    const deleteSubSection = async (parentMarker, subQuestion, parentIndex, subIndex) => {
        // If sub-question has qid, it's saved - delete from server
        if (subQuestion?.qid) {
            let data = {
                deletedQuestions: [subQuestion.qid]
            }
            updateModuleContent('', selectedModule._id, data).then(() => {
                // Also update local state immediately to provide instant feedback
                const updatedForms = [...markerForms];
                const filteredSubQuestions = updatedForms[parentIndex].sub_questions.filter((subQ, index) => index !== subIndex);
                const reRankedSubQuestions = filteredSubQuestions.map((subQ, index) => ({
                    ...subQ,
                    rank: index + 1
                }));
                updatedForms[parentIndex].sub_questions = reRankedSubQuestions;
                setMarkerForms(updatedForms);

                // Then refresh from server to ensure consistency
                getModuleContent(selectedModule);
                CustomToast.success("Sub-section deleted successfully");
            })
        } else {
            // If sub-question doesn't have qid, it's unsaved - remove from state and update ranks
            const updatedForms = [...markerForms];
            const filteredSubQuestions = updatedForms[parentIndex].sub_questions.filter((subQ, index) => index !== subIndex);

            // Re-rank all remaining sub-questions to ensure sequential ranking
            const reRankedSubQuestions = filteredSubQuestions.map((subQ, index) => ({
                ...subQ,
                rank: index + 1
            }));

            updatedForms[parentIndex].sub_questions = reRankedSubQuestions;
            setMarkerForms(updatedForms);
            CustomToast.success("Sub-section deleted successfully")
        }
    }

    const handleAdditionalEditorChange = (data) => {
        setcourseContent(data)
    };


    const handleFileChange = async (event) => {
        const file = event.target.files[0];

        await setSelectedFile(file);
        // Show preview
        if (file) {

            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewUrl(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            setPreviewUrl(null);
        }

    };

    const handleImageUpload = async (e, name, i, oi) => {
        if (e) {
            try {
                // Calling the new function to upload the rating
                const result = await apiFunctions.uploadImage(`${baseUrl}uploadImage`, e);
                await setFile_path(result.data.file_path)
                // Update the courseContent with the image URL
                if (name == "content") {
                    setcourseContent((prevContent) => {
                        return prevContent.replace(/<figure class="image"><img><\/figure>/g, `<figure className="image"><img src="${result.data.file}"></figure>`);
                    });
                }
                else if (name == "trance") {
                    setTrance((prevContent) => {
                        return prevContent.replace(/<figure class="image"><img><\/figure>/g, `<figure className="image"><img src="${result.data.file}"></figure>`);
                    });
                }
                else if (name == "Q") {
                    const updatedForms = [...markerForms];
                    updatedForms[i].content = updatedForms[i].content.replace(/<figure class="image"><img><\/figure>/g, `<figure className="image"><img src="${result.data.file}"></figure>`);
                    setMarkerForms(updatedForms);

                    console.log("Q", markerForms);

                }
                else if (name == "O") {
                    const updatedForms = [...markerForms];
                    updatedForms[i].options[oi].content = updatedForms[i].options[oi].content.replace(/<figure class="image"><img><\/figure>/g, `<figure className="image"><img src="${result.data.file}"></figure>`);
                    setMarkerForms(updatedForms);
                }


                return result.data.file_path;
            } catch (error) {
                console.error('Image upload error:', error);
                CustomToast.error('Error while uploading file');
            }

        }
        else {
            //alert('Please select an image');
            CustomToast.error('Please select an image');
            return;
        }

    };

    const handleFileVChange = (event) => {
        const file = event.target.files[0];

        setSelectedVFile(file);

        // Show preview
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewVUrl(reader.result);
            };
            reader.readAsArrayBuffer(file);
            // console.log("========>", file?.size)

            if (file && file?.size >= 100 * 1024 * 1024) {
                CustomToast.error('Size of the video should not exceed 100MB');
                return;
            }
            // handleVideoUpload()
        } else {
            setPreviewVUrl(null);
        }
    };

    const handleRemoveVideo = (event) => {
        setUrl(null)
        setFile_path(null)
        setPreviewVUrl(null)
        setSelectedVFile(null)
    }

    const handleVideoUpload = async () => {
        setLoader(true);
        if (!selectedVFile) {
            // alert('Please select a video');
            CustomToast.error('Please select a video');
            return;
        }
        try {
            const result = await apiFunctions.uploadVideo(`${baseUrl}uploadVideo`, selectedVFile);
            setFile_path(result.data.file);
            setLoader(false);
            CustomToast.success('Video uploaded successfully');
        } catch (error) {
            setLoader(false);
            console.error('Video upload error:', error);
            CustomToast.error('Video upload error');
        }
    };


    const handleCarouselFileChange = (e) => {
        const files = Array.from(e.target.files);
        setSelectedCarouselFiles(files);
    };

    const handleCarouselImageUpload = async () => {
        if (selectedCarouselFiles?.length === 0) {
            CustomToast.error('No Image selected');
            return;
        }

        setLoader(true);

        try {
            const response = await apiFunctions.uploadFiles(`${baseUrl}uploadFiles`, selectedCarouselFiles);
            const uploadedUrls = response.data?.urls || [];
            setUploadedCarouselUrls(prev => [...prev, ...uploadedUrls]);
            setSelectedCarouselFiles([]);
            setLoader(false);

            // Clear the file input
            if (carouselFilesInputRef.current) {
                carouselFilesInputRef.current.value = '';
            }

            CustomToast.success('Images uploaded successfully');
        } catch (error) {
            setLoader(false);
            console.error("Upload error:", error);
        } finally {
            setLoader(false);
        }
    };

    const handleRemoveCarouselFile = (index) => {
        const updatedUrls = [...uploadedCarouselUrls];
        updatedUrls.splice(index, 1);
        setUploadedCarouselUrls(updatedUrls);

        // Clear the file input
        if (carouselFilesInputRef.current) {
            carouselFilesInputRef.current.value = '';
        }

        CustomToast.success("Image removed successfully");
    };

    const moveCarouselImageUp = (index) => {
        if (index > 0) {
            const updatedUrls = [...uploadedCarouselUrls];
            [updatedUrls[index - 1], updatedUrls[index]] = [updatedUrls[index], updatedUrls[index - 1]];
            setUploadedCarouselUrls(updatedUrls);
        }
    };

    const moveCarouselImageDown = (index) => {
        if (index < uploadedCarouselUrls.length - 1) {
            const updatedUrls = [...uploadedCarouselUrls];
            [updatedUrls[index], updatedUrls[index + 1]] = [updatedUrls[index + 1], updatedUrls[index]];
            setUploadedCarouselUrls(updatedUrls);
        }
    };

    const handleDocumentChange = (e) => {
        const file = e.target.files[0];

        console.log("file", file);

        if (!file) return;

        if (file.size > 50 * 1024 * 1024) {
            alert(`File exceeds the 50MB size limit.`);
            return;
        }
        setSelectedDocuments(file);
    };

    const handleUploadDocuments = async () => {
        if (!selectedDocuments || selectedDocuments?.length === 0) {
            CustomToast.error("No document selected.");
            return;
        }

        if (selectedDocuments?.length > 1) {
            CustomToast.error("Please select only one document.");
            return;
        }

        setIsUploading(true);
        setLoader(true);
        try {
            const response = await apiFunctions.uploadDocFiles(`${baseUrl}uploadFiles`, selectedDocuments);
            setUploadedDocumentUrls(response.data.urls.join(','));
            setSelectedDocuments(null);
            setLoader(false);

            // Clear the file input
            if (documentFileInputRef.current) {
                documentFileInputRef.current.value = '';
            }

            CustomToast.success("Document uploaded successfully.");
        } catch (error) {
            setLoader(false);
            console.error("Upload error:", error);
            CustomToast.error("Error uploading document.");
        }
    };

    const handleRemoveDocument = (index) => {
        setUploadedDocumentUrls(null);
        setIsDocumentChecked(false);
        // Clear the file input
        if (documentFileInputRef.current) {
            documentFileInputRef.current.value = '';
        }
    };

    const getModuleContent = (data) => {
        setSelectedModule(data)
        
        // Update subModules state when a module is selected
        if (data?.sub_modules) {
            setSubModules(data.sub_modules);
        } else {
            // If this is a submodule being selected, find its parent's submodules
            const parentModule = maduleList.find(module => 
                module.sub_modules && module.sub_modules.some(sub => sub._id === data._id)
            );
            if (parentModule) {
                setSubModules(parentModule.sub_modules);
            }
        }
        
        fetchModuleContent(data._id).then((data) => {
            sessionStorage.setItem("selectedModuleId", data?.data?.module_id);
            if (data.status == true) {
                switch (data?.data?.type) {
                    case 'content':
                        setSelectedContentType(data?.data?.type)
                        setcontentType(data?.data?.content_type)
                        setcourseContent(data?.data?.content)
                        data.type = selectedContentType;
                        data.content = courseContent;
                        // data.url = file_path;
                        break;
                    case 'image':
                        setSelectedContentType(data?.data?.type)
                        break;
                    case 'carousal':
                        setSelectedContentType(data?.data?.type)
                        setcontentType(data?.data?.content_type)
                        setcourseContent(data?.data?.content)
                        setUploadedCarouselUrls(data?.data?.carousal_url || []);
                        break;
                    case 'document':
                        setSelectedContentType(data?.data?.type)
                        setcontentType(data?.data?.content_type)
                        setcourseContent(data?.data?.content)
                        setUploadedDocumentUrls(data?.data?.document);
                        setIsDocumentChecked(data?.data?.downloadable || false);
                        break;
                    case 'video':
                        setSelectedContentType(data?.data?.type)
                        setUrl(data?.data?.url)
                        setTrance(data?.data?.transcript)
                        setTestType('in_video')
                        if (data?.data?.questions) {
                            // Add tempId to existing questions for proper key management and ensure sequential ranking
                            const questionsWithTempId = data.data.questions.map((question, index) => ({
                                ...question,
                                tempId: question.qid || Date.now() + Math.random()
                            }));
                            // Re-rank all questions to ensure sequential ranking
                            const reRankedQuestions = reRankAllQuestions(questionsWithTempId);
                            setMarkerForms(reRankedQuestions);
                        }
                        else {
                            setMarkerForms({
                                tempId: Date.now() + Math.random(), // Add unique temporary ID
                                video_marking: '',
                                question_type: 'single_choice',
                                ans_view: 'show_ans',
                                content: '',
                                options: [{}],
                                correctAnswer: '',
                                sub_questions: [{
                                    video_marking: '',
                                    question_type: 'single_choice',
                                    ans_view: 'show_ans',
                                    content: '',
                                    options: [{}],
                                    correctAnswer: '',
                                    crt_ans_exp: '',
                                    wrng_ans_exp: '',
                                    marks: 1,
                                    rank: 1
                                }],
                                rating: { min: 0, max: 0, ans: 0 },
                                crt_ans_exp: '',
                                wrng_ans_exp: '',
                                marks: 1,
                                rank: 1,
                                question_tag: ''
                            })

                        }
                        break;
                    case 'test':
                        setMaxAttempt(data?.data?.max_attempts)
                        setPassingPercentages(data?.data?.passing_percent)
                        setSelectedContentType(data?.data?.type)
                        setcourseContent(data?.data?.content)
                        setTestType(data?.data?.course_test_type)
                        setIsEligible(data?.data?.test_skipable || false)
                        setTags(data?.data?.test_tag)
                        if (data?.data?.questions)
                            setMarkerForms(data?.data?.questions)
                        else {
                            setMarkerForms({
                                video_marking: '',
                                question_type: 'single_choice',
                                ans_view: 'show_ans',
                                content: '',
                                options: [{}],
                                correctAnswer: '',
                                crt_ans_exp: '',
                                sub_questions: [{
                                    video_marking: '',
                                    question_type: 'single_choice',
                                    ans_view: 'show_ans',
                                    content: '',
                                    options: [{}],
                                    correctAnswer: '',
                                    crt_ans_exp: '',
                                    wrng_ans_exp: '',
                                    marks: 1,
                                    rank: 1
                                }],
                                rating: { min: 0, max: 0, ans: 0 },
                                wrng_ans_exp: '',
                                marks: 1,
                                rank: 1,
                                maxAttempt: '',
                                passingPercentages: '',
                                question_tag: ''
                            })

                        }
                        break;

                    default:
                        setSelectedContentType('')
                }
            }
        })
    }


    const handleSave = async () => {
        await editModule()
        closeEditModal();
    };
    const handleSaveDelete = async () => {
        await DeleteModule()
        closeDeleteModal();
    };

    const handleCheckboxChange = (event, formIndex) => {
        const updatedForms = [...markerForms];
        const optionIndex = event.target.id.split('-')[1]; // Extracting option index from the event target id

        // For single-choice questions, uncheck all other options when one is checked
        if (updatedForms[formIndex].question_type === 'single_choice') {
            updatedForms[formIndex].options.forEach((option, index) => {
                updatedForms[formIndex].options[index].is_correct = index === parseInt(optionIndex);
            });
        } else {
            // For multi-choice questions, toggle the selected option
            updatedForms[formIndex].options[optionIndex].is_correct = event.target.checked;
        }

        setMarkerForms(updatedForms);
    };
    const handleSubCheckboxChange = (event, index, subIndex, suboptionIndex) => {
        const updatedForms = [...markerForms];
        const optionIndex = event.target.id.split('-')[1]; // Extracting option index from the event target id
        let q = updatedForms[index]?.sub_questions[subIndex]
        // For single-choice questions, uncheck all other options when one is checked
        if (updatedForms[index]?.sub_questions[subIndex]?.question_type === 'single_choice') {
            updatedForms[index]?.sub_questions[subIndex]?.options.forEach((option, index) => {
                q.options[index].is_correct = index === parseInt(optionIndex);
            });
        } else {
            // For multi-choice questions, toggle the selected option
            updatedForms[index].sub_questions[subIndex].options[optionIndex].is_correct = event.target.checked;
        }

        setMarkerForms(updatedForms);
    };

    const handleCorrectAnswerChange = (event, formIndex) => {
        const updatedForms = [...markerForms];
        const correctAnswer = event.target.value;

        // Ensure that correct answer is a valid option
        const isValidOption = updatedForms[formIndex].options.some((option) => option.content === correctAnswer);

        if (isValidOption) {
            updatedForms[formIndex].correctAnswer = correctAnswer;
            setMarkerForms(updatedForms);
        } else {
            // Handle invalid correct answer (optional)
            console.error('Invalid correct answer:', correctAnswer);
            CustomToast.error('Invalid correct answer:', correctAnswer);
        }
    };

    const handleCKEditorChange = (optionIndex, event, editor, formIndex) => {
        const updatedForms = [...markerForms];
        updatedForms[formIndex].options[optionIndex].content = editor.getData();
        setMarkerForms(updatedForms);
    };

    const handlesubCKEditorChange = (index, optionIndex, event, editor, formIndex) => {
        const updatedForms = [...markerForms];
        updatedForms[index].sub_questions[formIndex].options[optionIndex].content = editor.getData();
        setMarkerForms(updatedForms);
    };

    const handleSubCorrectAnswerExplanationChange = (event, index, editor, subIndex, formIndex) => {
        const updatedForms = [...markerForms];
        updatedForms[index].sub_questions[subIndex].crt_ans_exp = editor.getData();
        setMarkerForms(updatedForms);
    };

    const handleSubWrongAnswerExplanationChange = (event, index, editor, subIndex, formIndex) => {
        const updatedForms = [...markerForms];
        updatedForms[index].sub_questions[subIndex].wrng_ans_exp = editor.getData();
        setMarkerForms(updatedForms);
    };

    const handleCorrectAnswerExplanationChange = (event, index, editor) => {
        const updatedForms = [...markerForms];
        updatedForms[index].crt_ans_exp = editor.getData();
        setMarkerForms(updatedForms);
    };

    const handleWrongAnswerExplanationChange = (event, index, editor) => {
        const updatedForms = [...markerForms];
        updatedForms[index].wrng_ans_exp = editor.getData();
        setMarkerForms(updatedForms);
    };

    const reset = () => {
        setMarkerForms(
            [{
                video_marking: '',
                question_type: 'single_choice',
                ans_view: 'show_ans',
                content: '',
                options: [{}],
                correctAnswer: '',
                crt_ans_exp: '',
                wrng_ans_exp: '',
                sub_questions: [{
                    video_marking: '',
                    question_type: 'single_choice',
                    ans_view: 'show_ans',
                    content: '',
                    options: [{}],
                    correctAnswer: '',
                    crt_ans_exp: '',
                    wrng_ans_exp: '',
                    marks: 1,
                    rank: 1
                }],
                rating: { min: 0, max: 0, ans: 0 },
                marks: 1,
                rank: 1,
                question_tag: ''

            }]
        );
        setMaxAttempt('')
        setPassingPercentages('')
        setTrance('');
        setcourseContent('')
        setcontentType('')
        setUrl(null)
        setFile_path(null)
        setPreviewVUrl(null)
        setSelectedVFile(null)
        setTestType('')
        setIsEligible('')
        setTags('')
        setUploadedCarouselUrls([])
        setUploadedDocumentUrls('')
        setSelectedDocuments(null)
        setSelectedFile(null)
        setPreviewUrl(null)
        setIsDocumentChecked(false)
        setMarkerForms('')
        setMarkerForms([{
            video_marking: '',
            question_type: 'single_choice',
            ans_view: 'show_ans',
            content: '',
            options: [{}],
            correctAnswer: '',
            crt_ans_exp: '',
            sub_questions: [{
                video_marking: '',
                question_type: 'single_choice',
                ans_view: 'show_ans',
                content: '',
                options: [{}],
                correctAnswer: '',
                crt_ans_exp: '',
                wrng_ans_exp: '',
                marks: 1,
                rank: 1
            }],
            rating: { min: 0, max: 0, ans: 0 },
            wrng_ans_exp: '',
            marks: 1,
            rank: 1,
            maxAttempt: '',
            passingPercentages: '',
            question_tag: ''
        }])

    }

    const handleTestTypeChange = (event) => {
        setTestType(event.target.value);
    };

    const handleCOntetnTypeChange = (event) => {
        setcontentType(event.target.value);
    };

    const handleEligibilityChange = (event) => {
        setIsEligible(event.target.value || false);
    };

    /*  const handleModuleDrop = (result, data) => {
          if (!result.destination) {
            return;
          }
        
          const updatedModules = Array.from(data.sub_modules);
          const [movedModule] = updatedModules.splice(result.source.index, 1);
          updatedModules.splice(result.destination.index, 0, movedModule);
        
          setModuleList(updatedModules);
        }; */
    //main 
    const moveSubModules = (currentIndex, targetIndex, subModules) => {
        // Ensure valid indices
        let cModuleId;
        let updatedModule = []
        let promiseArr = []
        if (
            currentIndex < 0 ||
            targetIndex < 0 ||
            currentIndex >= subModules.length ||
            targetIndex >= subModules.length
        ) {
            console.error("Invalid index provided.");
            return;
        }

        // Create a copy of the subModules array
        const updatedSubModules = [...subModules];

        // Swap submodules at currentIndex and targetIndex
        const temp = updatedSubModules[currentIndex];
        updatedSubModules[currentIndex] = updatedSubModules[targetIndex];
        updatedSubModules[targetIndex] = temp;

        const [firstModule, secondModule] = [updatedSubModules[currentIndex], updatedSubModules[targetIndex]];
        if (firstModule && secondModule) {
            const tempRank = firstModule.rank;
            firstModule.rank = secondModule.rank;
            secondModule.rank = tempRank;
            updatedModule.push(firstModule)
            updatedModule.push(secondModule)
        }

        // Update the subModules state with the updated submodules
        setSubModules(updatedSubModules);

        // Update the moduleList with the updated submodules
        const updatedModuleList = maduleList.map((module) => {
            // Check if this module contains any of the moved submodules
            if (module.sub_modules && module.sub_modules.length > 0) {
                const hasMatchingSubmodule = updatedSubModules.some(subMod => 
                    module.sub_modules.some(existingSub => existingSub._id === subMod._id)
                );
                
                if (hasMatchingSubmodule) {
                    cModuleId = module.common_module_id;
                    return { ...module, sub_modules: updatedSubModules };
                }
            }
            return module;
        });

        // Update the moduleList state with the new list
        setModuleList(updatedModuleList);

        // Update ranks in the database
        if (updatedModule.length > 0) {
            promiseArr = updatedModule.map((ele => {
                const payload = {
                    rank: ele.rank,
                    _id: ele._id
                }
                return payload
            }))

            const finalPayload = {
                editedModules: promiseArr,
                course_meta_id: updatedSubModules[0]?.course_meta_id || sessionStorage.getItem('courseId')
            }
            updateModules(finalPayload).then((data) => {
                getCourseModuleList()
                CustomToast.success("Content saved successfully")
            }).catch((error) => {
                CustomToast.error("Error while save content")
            })
        }
    };

    return (
        <>
            <aside className={`course_details_sidebar sidebar ${show ? "review" : " "} `} id="admin-dash-nav">
                <div className='d-flex flex-column justify-content-between'>
                    {/* {console.log(courseContent)} */}
                    <div class="row mb-4"><div class="col-md-12"><h5>{courseName}</h5></div></div>
                    <div className='row'>
                        <div className="course-modules">
                            <div className=' justify-content-between w-100 align-items-center' style={{ display: 'block!important' }}>
                                {maduleList && maduleList?.map((data, index) => {

                                    const subModules = data && data?.sub_modules.map((ele => {
                                        ele['parent_id'] = data?._id
                                        return ele
                                    }))

                                    return <div key={index} style={{ border: "1px solid #a9a9a9f4", marginBottom: "12px" }}>
                                        <div className='module-box d-flex justify-content-between align-items-center' onClick={() => getModuleContent(data)}>
                                            <h5 className={data?._id === selectedModule?._id ? 'active' : ''}><img src="/images/module.svg"></img> {data.title}</h5>

                                            <div className="d-flex align-items-center justify-content-center text-decoration-none cursor_pointer dropdown-toggle" id="dropdownUser3" data-bs-toggle="dropdown" aria-expanded="false">
                                                <img src="/images/add-more.png"></img>
                                            </div>

                                            <ul className="dropdown-menu text-small shadow" aria-labelledby="dropdownUser3">
                                                <li>
                                                    <button className="dropdown-item" onClick={() => handleAddSubModuleClick(data.common_module_id)}>
                                                        <img src="/images/add.png"></img>Add
                                                    </button>
                                                </li>
                                                <li>
                                                    <button className="dropdown-item" onClick={() => openEditModal(data)}>
                                                        <img src="/images/edit.svg" style={{ width: '18px' }}></img>Edit
                                                    </button>
                                                    <Modal
                                                        isOpen={isEditModalOpen}
                                                        onRequestClose={closeEditModal}
                                                        contentLabel="Edit Modal"
                                                        className='editModal'
                                                    >
                                                        <div className='modulename-edit-form p-4 w-75 card'>
                                                            <form>
                                                                <label className='w-100 mb-2'>
                                                                    Edit Module Name: </label>
                                                                <input
                                                                    type="text"
                                                                    value={maduleEditName}
                                                                    className='form-control w-100'
                                                                    onChange={(e) => seteditModuleName(e.target.value)}

                                                                />

                                                                <div className='d-flex justify-content-between align-items-center mt-4'>
                                                                    <button type="button" className='btn btn-md w-100 p-2 btn-secondary me-2' onClick={closeEditModal}>
                                                                        Cancel
                                                                    </button>
                                                                    <button type="button" className='btn btn-md w-100 p-2 btn-primary' onClick={handleSave}>
                                                                        Save
                                                                    </button>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </Modal>
                                                    <Modal
                                                        isOpen={isDeleteModalOpen}
                                                        onRequestClose={closeDeleteModal}
                                                        contentLabel="Delete Modal"
                                                        className='editModal'
                                                    >
                                                        <div className='modulename-edit-form p-4 w-75 card'>
                                                            <form>
                                                                <label className='w-100 font-18'>
                                                                    Do you want to Delete Module?
                                                                </label>
                                                                <div className='d-flex justify-content-between align-items-center mt-4'>
                                                                    <button type="button" className='btn btn-md w-100 p-2 btn-secondary me-2' onClick={closeDeleteModal}>
                                                                        Cancel
                                                                    </button>
                                                                    <button type="button" className='btn btn-md w-100 p-2 btn-primary' onClick={handleSaveDelete}>
                                                                        Delete
                                                                    </button>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </Modal>
                                                </li>
                                                <li>
                                                    <button className="dropdown-item" onClick={() => openDeleteModal(data)}>
                                                        <img src="/images/delete.png"></img>Delete
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>

                                        {isSubModuleInputVisible && (data.common_module_id === selectedSubModule) ?
                                            <div className='row mb-35'>
                                                <div className='col-md-12'>
                                                    <label htmlFor="submodule_title" className="form-label">Submodule Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="submodule_title"
                                                        placeholder="Enter submodule name"
                                                        value={submoduleName}
                                                        onChange={(e) => setSubmoduleName(e.target.value)}
                                                        onKeyDown={(e) => updateModule(e, true, data?.sub_modules.length + 1)}
                                                        required

                                                    />
                                                </div>
                                            </div>
                                            : null}


                                        {data?.sub_modules?.map((sub_modules, index) => {

                                            { console.log('selected submodule:', selectedModule._id) }

                                            return <div key={index}><div onClick={() => getModuleContent(sub_modules)} className='sub module-box d-flex justify-content-between align-items-center' style={{ width: "calc(100% - 20px)", marginLeft: "20px" }}>
                                                <h5 className={data?.sub_modules[index]?._id === selectedModule?._id ? 'active' : ''}><img src="/images/module.svg"></img> {sub_modules.title}</h5>

                                                <div className="d-flex align-items-center justify-content-center text-decoration-none cursor_pointer dropdown-toggle" id="dropdownUser3" data-bs-toggle="dropdown" aria-expanded="false">
                                                    <img src="/images/add-more.png"></img>
                                                </div>

                                                <ul className="dropdown-menu text-small shadow" aria-labelledby="dropdownUser3">
                                                    {index > 0 &&
                                                        <li>
                                                            <button className="dropdown-item ps-3" onClick={() => moveSubModules(index, index - 1, data?.sub_modules)}>
                                                                <img src="/images/arrow-up.png" width={18} height={20}></img>Move Up
                                                            </button>
                                                        </li>}
                                                    <li>
                                                        <button className="dropdown-item ps-3" onClick={() => handleAddSubModuleClick(sub_modules.common_module_id)}>
                                                            <img src="/images/add.png"></img>Add
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <button className="dropdown-item ps-3" onClick={() => openEditModal(sub_modules)}>
                                                            <img src="/images/edit.svg" style={{ width: '18px' }}></img>Edit
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <button className="dropdown-item ps-3" onClick={() => openDeleteModal(sub_modules)} >
                                                            <img src="/images/delete.png" ></img>Delete
                                                        </button>
                                                    </li>
                                                    {index < data?.sub_modules?.length - 1 &&
                                                        <li>
                                                            <button className="dropdown-item ps-3" onClick={() => moveSubModules(index, index + 1, data?.sub_modules)}>
                                                                <img src="/images/arrow-down.png" width={18} height={20}></img>Move Down
                                                            </button>
                                                        </li>}
                                                </ul>
                                            </div>
                                                {isSubModuleInputVisible && (sub_modules.common_module_id === selectedSubModule) ?
                                                    <div className='row mb-35 mx-0' style={{ width: "calc(100% - 20px)", marginLeft: "20px" }}>
                                                        <div className='col-md-12'>
                                                            <label htmlFor="submodule_title" className="form-label">SubSubmodule Name</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="submodule_title"
                                                                placeholder="Enter submodule name"
                                                                value={submoduleName}
                                                                onChange={(e) => setSubmoduleName(e.target.value)}
                                                                onKeyDown={(e) => updateModule(e, true, sub_modules?.sub_sub_module.length + 1)}
                                                            />
                                                        </div>
                                                    </div>
                                                    : null}
                                                {sub_modules && sub_modules?.sub_sub_module?.map(sub_sub_module => {
                                                    return <div onClick={() => getModuleContent(sub_sub_module)} className='nested-sub module-box d-flex justify-content-between align-items-center' style={{ width: "calc(100% - 40px)", marginLeft: "40px" }}>
                                                        <h5 className={sub_sub_module?._id === selectedModule?._id ? 'active' : ''}><img src="/images/module.svg"></img> {sub_sub_module.title}</h5>
                                                        <div className="d-flex align-items-center justify-content-center text-decoration-none cursor_pointer dropdown-toggle" id="dropdownUser3" data-bs-toggle="dropdown" aria-expanded="false">
                                                            <img src="/images/add-more.png"></img>
                                                        </div>

                                                        <ul className="dropdown-menu text-small shadow" aria-labelledby="dropdownUser3">

                                                            <li>
                                                                <button className="dropdown-item" onClick={() => openEditModal(sub_sub_module)}>
                                                                    <img src="/images/edit.svg" style={{ width: '18px' }}></img>Edit
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button className="dropdown-item" onClick={() => openDeleteModal(sub_sub_module)}>
                                                                    <img src="/images/delete.png" ></img>Delete
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                })}
                                            </div>
                                        })}
                                    </div>
                                })}
                            </div>
                            <div className='row mb-35 mx-0'>
                                <div className='col-md-12 add-module'>
                                    {isModuleInputVisible && (
                                        <div className='main-module'>
                                            <label htmlFor="module_name" className="form-label">Module Name</label>
                                            <input type="text" className="form-control" id="module_name" placeholder="Module Name" name="module_name" value={maduleName} onChange={(e) => setModuleName(e.target.value)} onKeyDown={(e) => updateModule(e, false, maduleList.length + 1)} />
                                        </div>
                                    )}
                                    <div className='d-flex justify-content-between w-100 align-items-center'>
                                        <button
                                            type="button"
                                            className='btn w-100 add_module'
                                            onClick={handleAddModuleClick}
                                        >
                                            + Add Module
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </aside>


            <div className='course_main'>
                {/* <button onClick={submitForm}>save data</button> */}
                <form>

                    {/* <div className='row mb-4'>
                        <div className="col-md-6">
                            <label for="courseTitle" className="form-label">{courseName}</label>
                        </div>
                    </div> */}

                    <div className='row mb-35'>
                        <div className="col-md-12">
                            <label for="course_title" className="form-label">Submodule Name</label>
                            <input type="text" className="form-control" id="course_title" placeholder="Introduction" value={selectedModule?.title} name="course_title" />
                        </div>
                    </div>

                    {selectedContentType === "content" ?

                        <div className='row mb-35'>
                            <div className='col-md-12'>
                                <div className='text'>
                                    <div className='w-25'>
                                        <label htmlFor={``} className='col-form-label pt-0'>
                                            Content Type
                                        </label>
                                        <select
                                            id="testType"
                                            className='form-select'
                                            value={contentType}
                                            onChange={handleCOntetnTypeChange}
                                        >
                                            <option value='general'>General</option>
                                            <option value='copyright'>Copyright</option>
                                            <option value='feedback'>Feedback</option>
                                            <option value='last_module'>Last Module</option>
                                        </select>
                                    </div>
                                    <br />
                                    <div className='module_title'>
                                        <div className='d-flex justify-content-between align-items-center w-100'>
                                            <h5><img src="/images/module.svg"></img> <b className='fw-regular'>Text</b></h5>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <img src="/images/delete.svg"></img>
                                            </div>
                                        </div>
                                    </div>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={courseContent || ''}
                                        name="content"
                                        onReady={(editor) => {
                                            try {
                                                console.log("content", courseContent)
                                                editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                                                    return new MyUploadAdapter(loader, (e) => handleImageUpload(e, "content"));
                                                };
                                            } catch (error) {
                                                handleEditorError(error);
                                            }
                                        }}
                                        onError={handleEditorError}
                                        onChange={(event, editor) => handleAdditionalEditorChange(editor.getData())}
                                    />
                                </div>
                            </div>
                        </div>
                        : null
                    }
                    {selectedContentType === "carousal" ?
                        <div className="mt-4">
                            <div className='module_title'>
                                <div className='d-flex justify-content-between align-items-center w-100'>
                                    <h5><img src="/images/module.svg"></img> <b className='fw-regular'>Paragraph</b></h5>
                                    {/* <div className='d-flex justify-content-between align-items-center'>
                                        <img src="/images/delete.svg"></img>
                                    </div> */}
                                </div>
                            </div>
                            <CKEditor
                                // disabled
                                editor={ClassicEditor}
                                data={courseContent || ''}
                                name="content"
                                // config={ editorConfiguration }
                                onReady={(editor) => {
                                    console.log("content", courseContent)
                                    setupUploadAdapter(editor, "content");
                                }}
                                onError={handleEditorError}
                                onChange={(event, editor) => handleAdditionalEditorChange(editor.getData())}
                            />

                            <div className='video mt-4'>
                                <div className='module_title'>
                                    <div className='d-flex justify-content-between align-items-center w-100'>
                                        <h5><img src="/images/module.svg"></img> <b className='fw-regular'>Carousal</b></h5>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            {/* <img src="/images/delete.png" class="remove-pic" onClick={handleRemoveImage} /> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex flex-column align-items-center border p-3">
                                    <label
                                        htmlFor="fileInput"
                                        className="d-flex align-items-center gap-2 px-3 py-2 border rounded"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <img src="/images/File-icon.svg" alt="File Icon" width="20" height="20" />
                                        <span style={{ color: '#176D8C' }} className="fw-medium">Choose File</span>

                                    </label>

                                    <input
                                        ref={carouselFilesInputRef}
                                        id="fileInput"
                                        type="file"
                                        multiple
                                        onChange={handleCarouselFileChange}
                                        className="visually-hidden"
                                    />
                                    {selectedCarouselFiles.length > 0 && (
                                        <div className="mt-2 text-center w-100">
                                            {Array.from({ length: Math.ceil(selectedCarouselFiles.length / 5) }).map((_, chunkIndex) => {
                                                const start = chunkIndex * 5;
                                                const end = start + 5;
                                                const fileChunk = selectedCarouselFiles.slice(start, end);

                                                return (
                                                    <div key={chunkIndex} className="text-muted small">
                                                        {fileChunk.map((file, index) => (
                                                            <span key={index}>
                                                                {file.name}
                                                                {index < fileChunk.length - 1 ? ', ' : ''}
                                                            </span>
                                                        ))}
                                                    </div>
                                                );
                                            })}
                                           
                                        </div>
                                    )}

                                    <button
                                        type="button"
                                        className="btn btn-primary mt-3"
                                        style={{ width: "300px" }}
                                        onClick={handleCarouselImageUpload}
                                    >
                                        Add Images
                                    </button>
                                </div>

                            </div>

                            {loader ? <Loader /> :
                                <div className="mt-4">
                                    <h6>Uploaded Files</h6>
                                    {uploadedCarouselUrls.length > 0 ? (
                                        uploadedCarouselUrls.map((url, index) => (
                                            <div key={index} className="d-flex align-items-center mb-3 border p-2 rounded">
                                                <img
                                                    src={url}
                                                    alt={`uploaded-${index}`}
                                                    width={100}
                                                    height={80}
                                                    className="me-3"
                                                />
                                                <span className="me-auto">{url.split('/').pop()}</span>
                                                <div className="d-flex align-items-center gap-2">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-secondary"
                                                        onClick={() => moveCarouselImageUp(index)}
                                                        disabled={index === 0}
                                                        title="Move up"
                                                    >
                                                        <img src="/images/arrow-up.png" alt="Move up" width="16" height="16" />
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-secondary"
                                                        onClick={() => moveCarouselImageDown(index)}
                                                        disabled={index === uploadedCarouselUrls.length - 1}
                                                        title="Move down"
                                                    >
                                                        <img src="/images/arrow-down.png" alt="Move down" width="16" height="16" />
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm"
                                                        onClick={() => handleRemoveCarouselFile(index)}
                                                    >
                                                        <img src="/images/delete.png" className="remove-pic" alt="Remove" />
                                                    </button>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p>No images uploaded yet.</p>
                                    )}
                                </div>}

                        </div>
                        : null
                    }
                    {selectedContentType === "video" ?
                        <div>
                            <div className='row mb-35'>
                                <div className='col-md-12'>
                                    <div className='video'>
                                        <div className='module_title'>
                                            <div className='d-flex justify-content-between align-items-center w-100'>
                                                <h5><img src="/images/module.svg"></img> <b className='fw-regular'>Video</b></h5>
                                                <div className='d-flex justify-content-between align-items-center'>
                                                    <img src="/images/delete.png" class="remove-pic" onClick={handleRemoveVideo} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className='video_upload'>
                                            <input type="file" accept="video/*" onChange={handleFileVChange} />

                                            {previewVUrl ? (
                                                <> {loader ? <Loader /> : <>

                                                    <video
                                                        controls
                                                        width="200"
                                                        height="200"
                                                        style={{ marginTop: '10px' }}
                                                        key={URL.createObjectURL(selectedVFile)}
                                                    >
                                                        <source src={URL.createObjectURL(selectedVFile)} type={selectedVFile.type} />
                                                        Your browser does not support the video tag.
                                                    </video>
                                                </>
                                                } </>
                                            ) :
                                                url ? <>  <video
                                                    controls
                                                    width="200"
                                                    height="200"
                                                    style={{ marginTop: '10px' }}
                                                    key={url}
                                                >
                                                    <source src={url} type={url.type} />
                                                    Your browser does not support the video tag.
                                                </video></>
                                                    : null

                                            }

                                        </div>
                                    </div>
                                    <button type='button' className='btn btn-md px-5 btn-primary mt-4 me-2' onClick={handleVideoUpload}>Upload</button>
                                    {/* <button type='button' className='btn btn-md px-5 btn-primary mt-4 me-2' onClick={handleRemoveVideo}>Cancel</button> */}
                                </div>
                            </div>

                            <div className='row mb-35'>
                                <div className='col-md-12'>
                                    <div className='video'>
                                        <div className='module_title'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h5><b className='fw-regular'>Add Transcripts</b></h5>
                                            </div>
                                        </div>
                                        <CKEditor
                                            editor={ClassicEditor}
                                            data={trance || ''}
                                            name="trance"
                                            onReady={(editor) => {
                                                try {
                                                    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                                                        return new MyUploadAdapter(loader, (e) => handleImageUpload(e, "trance"));
                                                    };
                                                } catch (error) {
                                                    handleEditorError(error);
                                                }
                                            }}
                                            onError={handleEditorError}
                                            onChange={(event, editor) => {
                                                handleTranceEditorChange(event, editor)
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-35">
                                <div className="col-md-12">
                                    <div className="d-flex justify-content-start">
                                        <button
                                            type="button"
                                            className="add_markers_button"
                                            onClick={() => handleAddMarkerForm(markerForms.length + 1)}
                                        >
                                            + Add Marker Question
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div>
                                {markerForms?.map((marker, index) => (
                                    <div key={marker.tempId || marker.qid || index} className='row mb-35'>
                                        <div className='col-md-12'>
                                            <div className='video'>
                                                <div className='module_title'>
                                                    <div className='d-flex justify-content-between align-items-center'>
                                                        <h5>
                                                            <b className='fw-regular'>{`${index + 1}. Add Marker`} </b>
                                                        </h5>
                                                    </div>
                                                    <div className='d-flex justify-content-between align-items-center' onClick={() => deleteSection(marker)} style={{ cursor: 'pointer' }}>
                                                        <img src="/images/delete.svg"></img>
                                                    </div>
                                                </div>
                                                <div className='video_popup'>
                                                    <div className='row mb-4'>
                                                        <div className='col-md-4'>
                                                            <div className='row'>
                                                                <label htmlFor={`markerText-${index}`} className='col-sm-3 col-form-label'>
                                                                    {`Marker ${index + 1}`}
                                                                </label>
                                                                <div className='col-sm-9'>
                                                                    <input
                                                                        type='text'
                                                                        className='form-control'
                                                                        placeholder='00:00'
                                                                        id={`markerText-${index}`}
                                                                        value={marker.video_marking}
                                                                        onChange={(e) => {
                                                                            const updatedForms = [...markerForms];
                                                                            updatedForms[index].video_marking = e.target.value;
                                                                            setMarkerForms(updatedForms);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-4'>
                                                            <div className='row'>
                                                                <label htmlFor={`questionType-${index}`} className='col-sm-3 col-form-label'>
                                                                    Question Type
                                                                </label>
                                                                <div className='col-sm-9'>
                                                                    <select
                                                                        className='form-select'
                                                                        id={`questionType-${index}`}
                                                                        value={marker.question_type}
                                                                        onChange={(e) => {
                                                                            const updatedForms = [...markerForms];
                                                                            updatedForms[index].question_type = e.target.value;
                                                                            setMarkerForms(updatedForms);
                                                                        }}
                                                                    >
                                                                        <option value='single_choice'>Single Choice</option>
                                                                        <option value='multi_choice'>Multi Choice</option>
                                                                        <option value='para'>Paragraph</option>
                                                                        <option value='rating'>Rating</option>
                                                                        <option value='bool'>Boolean</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-4'>
                                                            <div className='row'>
                                                                <label htmlFor={`answerType-${index}`} className='col-sm-3 col-form-label'>
                                                                    Answer Type
                                                                </label>
                                                                <div className='col-sm-9'>
                                                                    <select
                                                                        className='form-select'
                                                                        id={`answerType-${index}`}
                                                                        value={marker.ans_view}
                                                                        onChange={(e) => {
                                                                            const updatedForms = [...markerForms];
                                                                            updatedForms[index].ans_view = e.target.value;
                                                                            setMarkerForms(updatedForms);
                                                                        }}
                                                                    >
                                                                        <option value="show_ans">Only Answer</option>
                                                                        <option value="show_ans_with_exp">Answer + Explanation</option>
                                                                        <option value="not_show_ans">Don’t Show Answer</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                             {/* added the question tag for video */}
                                            <div className='row mb-4'>
                                                <div className="col-md-12">
                                                    <label htmlFor={`tags-${index}`} className="form-label">Tags</label>
                                                    <input type="text" className="form-control" id={`tags-${index}`} placeholder="tags" value={marker.question_tag} name="tags" onChange={(e) => {
                                                        const updatedForms = [...markerForms];
                                                        updatedForms[index].question_tag = e.target.value;
                                                        setMarkerForms(updatedForms);
                                                    }} />
                                                </div>
                                            </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-12'>
                                                            <div style={{ position: 'relative' }}>
                                                                <CKEditor
                                                                    editor={ClassicEditor}
                                                                    data={marker.content || ''}
                                                                    name="Q"
                                                                    onReady={(editor) => {
                                                                        try {
                                                                            editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                                                                                return new MyUploadAdapter(loader, (e) => handleImageUpload(e, "Q", index));
                                                                            };
                                                                        } catch (error) {
                                                                            handleEditorError(error);
                                                                        }
                                                                    }}
                                                                    onError={handleEditorError}
                                                                    onChange={(event, editor) => handleEditorChange(event, editor, index)}
                                                                />
                                                                {/* <button type='button' className='img-upload' onClick={openModal}><img src='/images/image-upload-icon.svg' alt='img upload' ></img></button> */}
                                                            </div>

                                                            {/* <ImageUploadModal isOpen={isModalOpen} onClose={closeModal} /> */}

                                                        </div>
                                                    </div>

                                                    {marker.question_type === 'para' && marker.sub_questions?.map((sub_questions, subIndex) => (
                                                        <div key={subIndex} className='row mb-35'>
                                                            <div className='col-md-12'>
                                                                <div className='video'>
                                                                    <div className='module_title'>
                                                                        <div className='d-flex justify-content-between align-items-center'>
                                                                            <h5>
                                                                                <b className='fw-regular'>Add Markers</b>
                                                                            </h5>
                                                                        </div>
                                                                        <div className='d-flex justify-content-between align-items-center' onClick={() => deleteSubSection(marker, sub_questions, markerForms.findIndex(form => form === marker), subIndex)}>
                                                                            <img src="/images/delete.svg"></img>
                                                                        </div>
                                                                    </div>
                                                                    <div className='video_popup'>
                                                                        <div className='row mb-4'>
                                                                            <div className='col-md-4'>
                                                                                <div className='row'>
                                                                                    <label htmlFor={`markerText-${index}`} className='col-sm-3 col-form-label'>
                                                                                        {`Marker ${index + 1}`}
                                                                                    </label>
                                                                                    <div className='col-sm-9'>
                                                                                        <input
                                                                                            type='text'
                                                                                            className='form-control'
                                                                                            placeholder='00:00'
                                                                                            id={`markerText-${index}`}
                                                                                            value={sub_questions.video_marking}
                                                                                            onChange={(e) => {
                                                                                                const updatedForms = [...markerForms];
                                                                                                updatedForms[index].sub_questions[subIndex].video_marking = e.target.value;
                                                                                                setMarkerForms(updatedForms);
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <div className='col-md-4'>
                                                                                <div className='row'>
                                                                                    <label htmlFor={`questionType-${index}`} className='col-sm-3 col-form-label'>
                                                                                        Question Type
                                                                                    </label>
                                                                                    <div className='col-sm-9'>
                                                                                        <select
                                                                                            className='form-select'
                                                                                            id={`questionType-${index}`}
                                                                                            value={sub_questions.question_type}
                                                                                            onChange={(e) => {
                                                                                                const updatedForms = [...markerForms];
                                                                                                updatedForms[index].sub_questions[subIndex].question_type = e.target.value;
                                                                                                setMarkerForms(updatedForms);
                                                                                            }}
                                                                                        >
                                                                                            <option value='single_choice'>Single Choice</option>
                                                                                            <option value='multi_choice'>Multi Choice</option>
                                                                                            {/* <option value='para'>Paragraph</option> */}
                                                                                            {/* <option value='rating'>Rating</option> */}
                                                                                            {/* <option value='bool'>Boolean</option> */}
                                                                                        </select>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <div className='col-md-4'>
                                                                                <div className='row'>
                                                                                    <label htmlFor={`answerType-${index}`} className='col-sm-3 col-form-label'>
                                                                                        Answer Type
                                                                                    </label>
                                                                                    <div className='col-sm-9'>
                                                                                        <select
                                                                                            className='form-select'
                                                                                            id={`answerType-${index}`}
                                                                                            value={sub_questions.ans_view}
                                                                                            onChange={(e) => {
                                                                                                const updatedForms = [...markerForms];
                                                                                                updatedForms[index].sub_questions[subIndex].ans_view = e.target.value;
                                                                                                setMarkerForms(updatedForms);
                                                                                            }}
                                                                                        >
                                                                                            <option value="show_ans">Only Answer</option>
                                                                                            <option value="show_ans_with_exp">Answer + Explanation</option>
                                                                                            <option value="not_show_ans">Don’t Show Answer</option>
                                                                                        </select>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className='row mb-3'>
                                                                            <div className='col-md-12'>
                                                                                <div style={{ position: 'relative' }}>
                                                                                    <CKEditor
                                                                                        editor={ClassicEditor}
                                                                                        data={sub_questions.content}
                                                                                        name="Q"
                                                                                        onChange={(event, editor) => handleSubEditorChange(event, editor, index, subIndex)}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className='row mb-3'>
                                                                            <div className='col-md-12'>
                                                                                {sub_questions.options.map((option, suboptionIndex) => (
                                                                                    <div className=''>
                                                                                        <p className='my-2'>{suboptionIndex + 1}</p>
                                                                                        <div key={suboptionIndex} className='form-check check-option'>
                                                                                            <div class="d-flex justify-content-end align-items-center pb-4"><img src="/images/delete.svg" alt='remove-option' onClick={() => handleParaRemoveOption(index, subIndex, suboptionIndex)} /></div>
                                                                                            <input
                                                                                                className='form-check-input'
                                                                                                type={sub_questions.question_type === 'single_choice' ? 'radio' : 'checkbox'}
                                                                                                value={option?.content}
                                                                                                id={`option-${suboptionIndex}-${index}`}
                                                                                                checked={option.is_correct || false}
                                                                                                onChange={(e) => handleSubCheckboxChange(e, index, subIndex, suboptionIndex)}
                                                                                            />
                                                                                            {/* <label className='form-check-label pl-20' htmlFor={`option-${optionIndex}-${index}`}> */}

                                                                                            <div style={{ paddingLeft: "20px", position: 'relative' }}>
                                                                                                <CKEditor
                                                                                                    editor={ClassicEditor}
                                                                                                    data={option?.content}
                                                                                                    // config={editorConfiguration}
                                                                                                    onReady={(editor) => console.log('Editor is ready to use!', editor)}
                                                                                                    onChange={(event, editor) => handlesubCKEditorChange(index, suboptionIndex, event, editor, subIndex)}
                                                                                                    onBlur={(event, editor) => console.log('Blur.', editor)}
                                                                                                    onFocus={(event, editor) => console.log('Focus.', editor)}
                                                                                                />
                                                                                            </div>
                                                                                            {/* </label> */}
                                                                                        </div>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                        <div className='row mb-3'>
                                                                            <div className='col-md-6'>
                                                                                <button className='btn btn-outline-secondary' type='button' onClick={() => handleParaAddOption(index, subIndex)}>
                                                                                    + Add Option
                                                                                </button>
                                                                            </div>
                                                                        </div>

                                                                        <div className='row mb-3'>
                                                                            <div className='col-md-12'>
                                                                                <label htmlFor={`correctAnswerExplanation-${index}`} className='col-sm-3 col-form-label'>
                                                                                    Correct answer explanation
                                                                                </label>
                                                                                <div className='col-sm-12'>
                                                                                    {/* <input
                                                                                        type='text'
                                                                                        className='form-control'
                                                                                        id={`correctAnswerExplanation-${index}`}
                                                                                        value={sub_questions.crt_ans_exp}
                                                                                        onChange={(e) => handleSubCorrectAnswerExplanationChange(e, subIndex, index)}
                                                                                    /> */}
                                                                                    <CKEditor
                                                                                        editor={ClassicEditor}
                                                                                        data={sub_questions?.crt_ans_exp}
                                                                                        id={`correctAnswerExplanation-${index}`}
                                                                                        onReady={(editor) => console.log('Editor is ready to use!', editor)}
                                                                                        onChange={(event, editor) =>
                                                                                            handleSubCorrectAnswerExplanationChange(event, index, editor, subIndex)
                                                                                        }
                                                                                        onBlur={(event, editor) => console.log('Blur.', editor)}
                                                                                        onFocus={(event, editor) => console.log('Focus.', editor)}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className='row mb-3'>
                                                                            <div className='col-md-12'>
                                                                                <label htmlFor={`wrongAnswerExplanation-${index}`} className='col-sm-3 col-form-label'>
                                                                                    Wrong answer explanation
                                                                                </label>
                                                                                <div className='col-sm-12'>
                                                                                    {/* <input
                                                                                        type='text'
                                                                                        className='form-control'
                                                                                        id={`wrongAnswerExplanation-${index}`}
                                                                                        value={sub_questions.wrng_ans_exp}
                                                                                        onChange={(e) => handleSubWrongAnswerExplanationChange(e, subIndex, index)}
                                                                                    /> */}

                                                                                    <CKEditor
                                                                                        editor={ClassicEditor}
                                                                                        data={sub_questions?.wrng_ans_exp}
                                                                                        id={`wrongAnswerExplanation-${index}`}
                                                                                        onReady={(editor) => console.log('Editor is ready to use!', editor)}
                                                                                        onChange={(event, editor) =>
                                                                                            handleSubWrongAnswerExplanationChange(event, index, editor, subIndex)
                                                                                        }
                                                                                        onBlur={(event, editor) => console.log('Blur.', editor)}
                                                                                        onFocus={(event, editor) => console.log('Focus.', editor)}
                                                                                    />

                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className='row mb-3'>
                                                                            <div className='col-md-6'>
                                                                                {subIndex === marker.sub_questions?.length - 1 && (
                                                                                    <button type="button" className='add_markers_button' onClick={(e) => handleSubAddMarkerForm(index, marker.sub_questions.length + 1)}>
                                                                                        + Add Marker Question
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    {marker.question_type === 'rating' && <>
                                                        <div className='col-md-12'>
                                                            <label htmlFor={`min-${index}`} className='col-sm-3 col-form-label'>
                                                                minimum value
                                                            </label>
                                                            <div className='col-sm-12'>
                                                                <input
                                                                    type='text'
                                                                    className='form-control'
                                                                    id={`min-${index}`}
                                                                    value={marker?.rating?.min}
                                                                    onChange={(e) => handleminChange(e, index)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className='col-md-12'>
                                                            <label htmlFor={`maximum-${index}`} className='col-sm-3 col-form-label'>
                                                                maximum value
                                                            </label>
                                                            <div className='col-sm-12'>
                                                                <input
                                                                    type='text'
                                                                    className='form-control'
                                                                    id={`maximum-${index}`}
                                                                    value={marker?.rating?.max}
                                                                    onChange={(e) => handlemaxChange(e, index)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className='col-md-12'>
                                                            <label htmlFor={`interval-${index}`} className='col-sm-3 col-form-label'>
                                                                Interval value
                                                            </label>
                                                            <div className='col-sm-12'>
                                                                <input
                                                                    type='text'
                                                                    className='form-control'
                                                                    id={`interval-${index}`}
                                                                    value={marker?.rating?.interval}
                                                                    onChange={(e) => handleintervalChange(e, index)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className='col-md-12'>
                                                            <label htmlFor={`Answer-${index}`} className='col-sm-3 col-form-label'>
                                                                Answer value
                                                            </label>
                                                            <div className='col-sm-12'>
                                                                <input
                                                                    type='text'
                                                                    className='form-control'
                                                                    id={`Answer-${index}`}
                                                                    value={marker?.rating?.ans}
                                                                    onChange={(e) => handleansChange(e, index)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </>}
                                                    {(marker.question_type === 'single_choice' || marker.question_type === 'multi_choice') && <div className='row mb-3'>
                                                        <div className='col-md-12'>
                                                            {marker.options.map((option, optionIndex) => (
                                                                <div className=''>
                                                                    <p className='my-2'>Option {optionIndex + 1}</p>
                                                                    <div key={optionIndex} className='form-check check-option'>
                                                                        <input
                                                                            className='form-check-input'
                                                                            type={marker.question_type === 'single_choice' ? 'radio' : 'checkbox'}
                                                                            value={option?.content}
                                                                            id={`option-${optionIndex}-${index}`}
                                                                            checked={option.is_correct || false}
                                                                            onChange={(e) => handleCheckboxChange(e, index)}
                                                                        />
                                                                        {/* <label className='form-check-label pl-20' htmlFor={`option-${optionIndex}-${index}`}> */}

                                                                        <div style={{ paddingLeft: "20px", position: 'relative' }}>
                                                                            <CKEditor
                                                                                editor={ClassicEditor}
                                                                                data={option?.content}
                                                                                // config={editorConfiguration}
                                                                                // onReady={(editor) => console.log('Editor is ready to use!', editor)}
                                                                                onReady={(editor) => {
                                                                                    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                                                                                        // Initialize your custom upload adapter with a function to be called on file upload
                                                                                        return new MyUploadAdapter(loader, (e) => handleImageUpload(e, "O", index, optionIndex));
                                                                                    };
                                                                                }}
                                                                                onChange={(event, editor) => handleCKEditorChange(optionIndex, event, editor, index)}
                                                                            // onBlur={(event, editor) => console.log('Blur.', editor)}
                                                                            // onFocus={(event, editor) => console.log('Focus.', editor)}
                                                                            />
                                                                        </div>


                                                                        {/* </label> */}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>}
                                                    {(marker.question_type === 'single_choice' || marker.question_type === 'multi_choice') && <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <button className='btn btn-outline-secondary' type='button' onClick={() => handleAddOption(index)}>
                                                                + Add Option
                                                            </button>
                                                        </div>
                                                    </div>}

                                                    <div className='row mb-3'>
                                                        <div className='col-md-12'>
                                                            <label htmlFor={`correctAnswerExplanation-${index}`} className='col-sm-3 col-form-label'>
                                                                Correct answer explanation
                                                            </label>
                                                            <div className='col-sm-12'>
                                                                {/* <input
                                                                    type='text'
                                                                    className='form-control'
                                                                    id={`correctAnswerExplanation-${index}`}
                                                                    value={marker.crt_ans_exp}
                                                                    onChange={(e) => handleCorrectAnswerExplanationChange(e, index)}
                                                                /> */}
                                                                <CKEditor
                                                                    editor={ClassicEditor}
                                                                    data={marker?.crt_ans_exp}
                                                                    id={`correctAnswerExplanation-${index}`}
                                                                    onReady={(editor) => console.log('Editor is ready to use!', editor)}
                                                                    onChange={(event, editor) =>
                                                                        handleCorrectAnswerExplanationChange(event, index, editor)
                                                                    }
                                                                    onBlur={(event, editor) => console.log('Blur.', editor)}
                                                                    onFocus={(event, editor) => console.log('Focus.', editor)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-12'>
                                                            <label htmlFor={`wrongAnswerExplanation-${index}`} className='col-sm-3 col-form-label'>
                                                                Wrong answer explanation
                                                            </label>
                                                            <div className='col-sm-12'>
                                                                {/* <input
                                                                    type='text'
                                                                    className='form-control'
                                                                    id={`wrongAnswerExplanation-${index}`}
                                                                    value={marker.wrng_ans_exp}
                                                                    onChange={(e) => handleWrongAnswerExplanationChange(e, index)}
                                                                /> */}
                                                                <CKEditor
                                                                    editor={ClassicEditor}
                                                                    data={marker?.wrng_ans_exp}
                                                                    id={`wrongAnswerExplanation-${index}`}
                                                                    onReady={(editor) => console.log('Editor is ready to use!', editor)}
                                                                    onChange={(event, editor) =>
                                                                        handleWrongAnswerExplanationChange(event, index, editor)
                                                                    }
                                                                    onBlur={(event, editor) => console.log('Blur.', editor)}
                                                                    onFocus={(event, editor) => console.log('Focus.', editor)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            {index === markerForms.length - 1 && (
                                                                <button className='add_markers_button' onClick={(e) => handleAddMarkerForm(markerForms.length + 1)}>
                                                                    + Add Marker Question
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div> : null}

                    {selectedContentType === "document" ?
                        <div className="mt-4">
                            <div className='module_title'>
                                <div className='d-flex justify-content-between align-items-center w-100'>
                                    <h5><img src="/images/module.svg"></img> <b className='fw-regular'>Paragraph</b></h5>
                                    {/* <div className='d-flex justify-content-between align-items-center'>
                                        <img src="/images/delete.svg"></img>
                                    </div> */}
                                </div>
                            </div>
                            <CKEditor
                                // disabled
                                editor={ClassicEditor}
                                data={courseContent || ''}
                                name="content"
                                // config={ editorConfiguration }
                                onReady={(editor) => {
                                    console.log("content", courseContent)
                                    setupUploadAdapter(editor, "content");
                                }}
                                onError={handleEditorError}
                                onChange={(event, editor) => handleAdditionalEditorChange(editor.getData())}
                            />

                            <div className='video mt-4'>
                                <div className='module_title'>
                                    <div className='d-flex justify-content-between align-items-center w-100'>
                                        <h5><img src="/images/module.svg"></img> <b className='fw-regular'>Document</b></h5>
                                    </div>
                                </div>
                                <div className="d-flex flex-column align-items-center border p-3">
                                    <input
                                        ref={documentFileInputRef}
                                        type="file"
                                        multiple={false}
                                        accept=".pdf,.doc,.docx,.xlsx,.xls,.ppt,.pptx,.txt"
                                        className="form-control"
                                        onChange={handleDocumentChange}
                                    />
                                    <div className="my-3">
                                        <button type="button" className="btn btn-primary" onClick={handleUploadDocuments}>
                                            Upload Documents
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {loader ? <Loader /> :
                                <div className="mt-4">
                                    <h6>Uploaded Document</h6>

                                    {uploadedDocumentUrls ? (
                                        <div className="d-flex align-items-center mb-3 border p-4 rounded">
                                            <a
                                                href={uploadedDocumentUrls}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="me-auto text-black text-decoration-none"
                                            >
                                                {decodeURIComponent(uploadedDocumentUrls.split('/').pop())}
                                            </a>

                                            <input
                                                type="checkbox"
                                                className="form-check-input me-2"
                                                checked={isDocumentChecked ? true : false}
                                                onChange={(e) => setIsDocumentChecked(e.target.checked)}
                                                id="documentCheckbox"
                                                style={{ width: '20px', height: '20px' }}
                                            />
                                            <span className="ms-1">Downloadable</span>

                                            <button
                                                type="button"
                                                className="btn btn-sm"
                                                onClick={() => handleRemoveDocument()}
                                            >
                                                <img src="/images/delete.png" className="remove-pic" alt="Remove" />
                                            </button>
                                        </div>
                                    ) : (
                                        <p>No document uploaded yet.</p>
                                    )}

                                </div>}

                        </div>
                        : null
                    }

                    {selectedContentType === "test" ? <div>
                        <div className='row mb-35'>
                            <div className='col-md-12'>
                                <div className='text'>

                                    <div className='d-flex justify-content-between align-items-center mb-35'>
                                        <div className='w-25'>
                                            <label htmlFor={``} className='col-form-label pt-0'>
                                                Test Type
                                            </label>
                                            <select
                                                id="testType"
                                                className='form-select'
                                                value={testType}
                                                onChange={handleTestTypeChange}
                                            >
                                                <option value="">Select test type</option>
                                                <option value='base_line'>Base Line</option>
                                                <option value='general_line'>General Line</option>
                                                <option value='end_line'>End Line</option>
                                            </select>
                                        </div>

                                        <div className='w-25'>
                                            <label htmlFor="isEligible" className='col-form-label pt-0'>
                                                Is Skippable ?
                                            </label>
                                            <select
                                                id="isEligible"
                                                className='form-select'
                                                value={isEligible}
                                                onChange={handleEligibilityChange}
                                            >
                                                <option value={false}>No</option>
                                                <option value={true}>Yes</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className='row mb-4'>
                                        <div className="col-md-12">
                                            <label for="tags" className="form-label">Tags</label>
                                            <input type="text" className="form-control" id="tags" placeholder="tags" value={tags} name="tags" onChange={(e) => setTags(e.target.value)} />
                                        </div>
                                    </div>

                                    <div className='module_title'>
                                        <div className='d-flex justify-content-between align-items-center w-100'>
                                            <h5><img src="/images/module.svg"></img> <b className='fw-regular'>Instruction</b></h5>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <img src="/images/delete.svg"></img>
                                            </div>
                                        </div>
                                    </div>
                                    <CKEditor
                                        // disabled
                                        editor={ClassicEditor}
                                        data={courseContent || ''}
                                        name="content"
                                        // config={ editorConfiguration }
                                        onReady={(editor) => {
                                            setupUploadAdapter(editor, "content");
                                        }}
                                        onError={handleEditorError}
                                        onChange={(event, editor) => handleAdditionalEditorChange(editor.getData())}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className='row mb-35'>
                            <div className="col-md-12 mb-4">
                                <label for="Max_attempt" className="form-label">Maximum Attempt <span className='red'>*</span></label>
                                <input type="text" className="form-control" id="Max_attempt" placeholder="Maximum Attempt Number" value={maxAttempt} name="Max_Attempt" onChange={(e) => setMaxAttempt(e.target.value)} required />
                            </div>
                            <div className="col-md-12">
                                <label for="Passing_Percentages" className="form-label">Passing Percentage <span className='red'>*</span></label>
                                <input type="text" className="form-control" id="Passing_Percentages" placeholder="Passing Percentage Number" value={passingPercentages} name="Passing_Percentages" onChange={(e) => setPassingPercentages(e.target.value)} required />
                            </div>
                        </div>

                        {markerForms?.map((marker, index) => (
                            <div key={marker.tempId || marker.qid || index} className='row mb-35'>
                                <div className='col-md-12'>
                                    <div className='video'>
                                        <div className='module_title'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h5>
                                                    <b className='fw-regular'>{index + 1}. Add Question</b>
                                                </h5>
                                            </div>
                                            <div className='d-flex justify-content-between align-items-center' onClick={() => deleteSection(marker)}>
                                                <img src="/images/delete.svg"></img>
                                            </div>

                                        </div>
                                        <div className='video_popup'>
                                            <div className='row mb-3'>
                                                <div className='col-md-4'>
                                                    <div className='row'>
                                                        <label htmlFor={`markerText-${index}`} className='col-sm-3 col-form-label'>
                                                            Marks
                                                        </label>
                                                        <div className='col-sm-9'>
                                                            <input
                                                                type='text'
                                                                className='form-control'
                                                                placeholder='numbers'
                                                                id={`markerText-${index}`}
                                                                value={marker.marks}
                                                                onChange={(e) => {
                                                                    const updatedForms = [...markerForms];
                                                                    updatedForms[index].marks = e.target.value;
                                                                    setMarkerForms(updatedForms);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-4'>
                                                    <div className='row'>
                                                        <label htmlFor={`questionType-${index}`} className='col-sm-3 col-form-label'>
                                                            Question Type
                                                        </label>
                                                        <div className='col-sm-9'>
                                                            <select
                                                                className='form-select'
                                                                id={`questionType-${index}`}
                                                                value={marker.question_type}
                                                                onChange={(e) => {
                                                                    const updatedForms = [...markerForms];
                                                                    updatedForms[index].question_type = e.target.value;
                                                                    setMarkerForms(updatedForms);
                                                                }}
                                                            >
                                                                <option value='single_choice'>Single Choice</option>
                                                                <option value='multi_choice'>Multi Choice</option>
                                                                <option value='para'>Paragraph</option>
                                                                <option value='rating'>Rating</option>
                                                                <option value='bool'>Boolean</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-4'>
                                                    <div className='row'>
                                                        <label htmlFor={`answerType-${index}`} className='col-sm-3 col-form-label'>
                                                            Answer Type
                                                        </label>
                                                        <div className='col-sm-9'>
                                                            <select
                                                                className='form-select'
                                                                id={`answerType-${index}`}
                                                                value={marker.ans_view}
                                                                onChange={(e) => {
                                                                    const updatedForms = [...markerForms];
                                                                    updatedForms[index].ans_view = e.target.value;
                                                                    setMarkerForms(updatedForms);
                                                                }}
                                                            >
                                                                <option value="show_ans">Only Answer</option>
                                                                <option value="show_ans_with_exp">Answer + Explanation</option>
                                                                <option value="not_show_ans">Don’t Show Answer</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* added the question tag */}
                                            <div className='row mb-4'>
                                                <div className="col-md-12">
                                                    <label htmlFor={`tags-${index}`} className="form-label">Tags</label>
                                                    <input type="text" className="form-control" id={`tags-${index}`} placeholder="tags" value={marker.question_tag} name="tags" onChange={(e) => {
                                                        const updatedForms = [...markerForms];
                                                        updatedForms[index].question_tag = e.target.value;
                                                        setMarkerForms(updatedForms);
                                                    }} />
                                                </div>
                                            </div>
                                            <div className='row mb-3'>
                                                <div className='col-md-12'>
                                                    <CKEditor
                                                        editor={ClassicEditor}
                                                        data={marker.content || ''}
                                                        // onReady={(editor) => console.log('Editor is ready to use!', editor)}
                                                        name="Q"
                                                        onReady={(editor) => {
                                                            try {
                                                                if (editor && editor.plugins) {
                                                                    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                                                                        // Initialize your custom upload adapter with a function to be called on file upload
                                                                        return new MyUploadAdapter(loader, (e) => handleImageUpload(e, "Q", index));
                                                                    };
                                                                }
                                                            } catch (error) {
                                                                handleEditorError(error);
                                                            }
                                                        }}
                                                        onError={handleEditorError}
                                                        onChange={(event, editor) => handleEditorChange(event, editor, index)}
                                                        onBlur={(event, editor) => console.log('Blur.', editor)}
                                                        onFocus={(event, editor) => console.log('Focus.', editor)}
                                                    />
                                                </div>
                                            </div>

                                            {marker.question_type === 'para' && marker.sub_questions?.map((sub_questions, subIndex) => (
                                                <div key={subIndex} className='row mb-35'>
                                                    <div className='col-md-12'>
                                                        <div className='video'>
                                                            <div className='module_title'>
                                                                <div className='d-flex justify-content-between align-items-center'>
                                                                    <h5>
                                                                        <b className='fw-regular'>Add Question</b>
                                                                    </h5>
                                                                </div>
                                                                <div className='d-flex justify-content-between align-items-center' onClick={() => deleteSubSection(marker, sub_questions, markerForms.findIndex(form => form === marker), subIndex)}>
                                                                    <img src="/images/delete.svg"></img>
                                                                </div>
                                                            </div>
                                                            <div className='video_popup'>
                                                                <div className='row mb-4'>
                                                                    {/* <div className='col-md-4'>
                                                                        <div className='row'>
                                                                            <label htmlFor={`markerText-${index}`} className='col-sm-3 col-form-label'>
                                                                                {`Marker ${index + 1}`}
                                                                            </label>
                                                                            <div className='col-sm-9'>
                                                                                <input
                                                                                    type='text'
                                                                                    className='form-control'
                                                                                    placeholder='00:00'
                                                                                    id={`markerText-${index}`}
                                                                                    value={sub_questions.video_marking}
                                                                                    onChange={(e) => {
                                                                                        const updatedForms = [...markerForms];
                                                                                        updatedForms[index].sub_questions[subIndex].video_marking = e.target.value;
                                                                                        setMarkerForms(updatedForms);
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div> */}

                                                {/* <div className='col-md-4'>
                                                    <div className='row'>
                                                        <label htmlFor={`markerText-${index}`} className='col-sm-3 col-form-label'>
                                                            Marks
                                                        </label>
                                                        <div className='col-sm-9'>
                                                            <input
                                                                type='text'
                                                                className='form-control'
                                                                placeholder='numbers'
                                                                id={`markerText-${index}`}
                                                                value={sub_questions.marks}
                                                                onChange={(e) => {
                                                                    const updatedForms = [...markerForms];
                                                                    updatedForms[index].sub_questions[subIndex].marks = e.target.value;
                                                                    setMarkerForms(updatedForms);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div> */}

                                                                    <div className='col-md-4'>
                                                                        <div className='row'>
                                                                            <label htmlFor={`questionType-${index}`} className='col-sm-3 col-form-label'>
                                                                                Question Type
                                                                            </label>
                                                                            <div className='col-sm-9'>
                                                                                <select
                                                                                    className='form-select'
                                                                                    id={`questionType-${index}`}
                                                                                    value={sub_questions.question_type}
                                                                                    onChange={(e) => {
                                                                                        const updatedForms = [...markerForms];
                                                                                        updatedForms[index].sub_questions[subIndex].question_type = e.target.value;
                                                                                        setMarkerForms(updatedForms);
                                                                                    }}
                                                                                >
                                                                                    <option value='single_choice'>Single Choice</option>
                                                                                    <option value='multi_choice'>Multi Choice</option>
                                                                                    {/* <option value='para'>Paragraph</option> */}
                                                                                    {/* <option value='rating'>Rating</option>
                                                                                    <option value='bool'>Boolean</option> */}
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className='col-md-4'>
                                                                        <div className='row'>
                                                                            <label htmlFor={`answerType-${index}`} className='col-sm-3 col-form-label'>
                                                                                Answer Type
                                                                            </label>
                                                                            <div className='col-sm-9'>
                                                                                <select
                                                                                    className='form-select'
                                                                                    id={`answerType-${index}`}
                                                                                    value={sub_questions.ans_view}
                                                                                    onChange={(e) => {
                                                                                        const updatedForms = [...markerForms];
                                                                                        updatedForms[index].sub_questions[subIndex].ans_view = e.target.value;
                                                                                        setMarkerForms(updatedForms);
                                                                                    }}
                                                                                >
                                                                                    <option value="show_ans">Only Answer</option>
                                                                                    <option value="show_ans_with_exp">Answer + Explanation</option>
                                                                                    <option value="not_show_ans">Don’t Show Answer</option>
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                 {/* added the question tag for para */}
                                            {/* <div className='row mb-4'>
                                                <div className="col-md-12">
                                                    <label htmlFor={`tags-${index}`} className="form-label">Tags</label>
                                                    <input type="text" className="form-control" id={`tags-${index}`} placeholder="tags" value={marker.question_tag} name="tags" onChange={(e) => {
                                                        const updatedForms = [...markerForms];
                                                        updatedForms[index].question_tag = e.target.value;
                                                        setMarkerForms(updatedForms);
                                                    }} />
                                                </div>
                                            </div> */}

                                                                <div className='row mb-3'>
                                                                    <div className='col-md-12'>
                                                                        <div className=''>
                                                                            {/* <p className='question-number me-2'>Q.{subIndex + 1}.</p> */}
                                                                            <div className='w-100' style={{ position: 'relative' }}>
                                                                                <CKEditor
                                                                                    editor={ClassicEditor}
                                                                                    data={sub_questions.content}
                                                                                    name="Q"
                                                                                    onChange={(event, editor) => handleSubEditorChange(event, editor, index, subIndex)}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='row mb-3'>
                                                                    <div className='col-md-12'>
                                                                        {sub_questions.options.map((option, suboptionIndex) => (
                                                                            <div className=''>
                                                                                <p className='option-number me-2 my-2'>Option {suboptionIndex + 1}</p>
                                                                                <div key={suboptionIndex} className='form-check check-option w-100'>
                                                                                    <div class="d-flex justify-content-end align-items-center pb-4"><img src="/images/delete.svg" alt='remove-option' onClick={() => handleParaRemoveOption(index, subIndex, suboptionIndex)} /></div>
                                                                                    <input
                                                                                        className='form-check-input'
                                                                                        type={sub_questions.question_type === 'single_choice' ? 'radio' : 'checkbox'}
                                                                                        value={option?.content}
                                                                                        id={`option-${suboptionIndex}-${index}`}
                                                                                        checked={option.is_correct || false}
                                                                                        onChange={(e) => handleSubCheckboxChange(e, index, subIndex, suboptionIndex)}
                                                                                    />
                                                                                    {/* <label className='form-check-label pl-20' htmlFor={`option-${optionIndex}-${index}`}> */}

                                                                                    <div style={{ paddingLeft: "20px", position: 'relative' }}>
                                                                                        <CKEditor
                                                                                            editor={ClassicEditor}
                                                                                            data={option?.content}
                                                                                            // config={editorConfiguration}
                                                                                            onReady={(editor) => console.log('Editor is ready to use!', editor)}
                                                                                            onChange={(event, editor) => handlesubCKEditorChange(index, suboptionIndex, event, editor, subIndex)}
                                                                                            onBlur={(event, editor) => console.log('Blur.', editor)}
                                                                                            onFocus={(event, editor) => console.log('Focus.', editor)}
                                                                                        />
                                                                                    </div>
                                                                                    {/* </label> */}
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                                <div className='row mb-3'>
                                                                    <div className='col-md-6'>
                                                                        <button className='btn btn-outline-secondary' type='button' onClick={() => handleParaAddOption(index, subIndex)}>
                                                                            + Add Option
                                                                        </button>
                                                                    </div>
                                                                </div>

                                                                <div className='row mb-3'>
                                                                    <div className='col-md-12'>
                                                                        <label htmlFor={`correctAnswerExplanation-${index}`} className='col-sm-3 col-form-label'>
                                                                            Correct answer explanation
                                                                        </label>
                                                                        <div className='col-sm-12'>
                                                                            {/* <input
                                                                                type='text'
                                                                                className='form-control'
                                                                                id={`correctAnswerExplanation-${index}`}
                                                                                value={sub_questions.crt_ans_exp}
                                                                                onChange={(e) => handleSubCorrectAnswerExplanationChange(e, subIndex, index)}
                                                                            /> */}
                                                                            <CKEditor
                                                                                editor={ClassicEditor}
                                                                                data={sub_questions?.crt_ans_exp}
                                                                                id={`correctAnswerExplanation-${index}`}
                                                                                onReady={(editor) => console.log('Editor is ready to use!', editor)}
                                                                                onChange={(event, editor) =>
                                                                                    handleSubCorrectAnswerExplanationChange(event, index, editor, subIndex)
                                                                                }
                                                                                onBlur={(event, editor) => console.log('Blur.', editor)}
                                                                                onFocus={(event, editor) => console.log('Focus.', editor)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className='row mb-3'>
                                                                    <div className='col-md-12'>
                                                                        <label htmlFor={`wrongAnswerExplanation-${index}`} className='col-sm-3 col-form-label'>
                                                                            Wrong answer explanation
                                                                        </label>
                                                                        <div className='col-sm-12'>
                                                                            {/* <input
                                                                                type='text'
                                                                                className='form-control'
                                                                                id={`wrongAnswerExplanation-${index}`}
                                                                                value={sub_questions.wrng_ans_exp}
                                                                                onChange={(e) => handleSubWrongAnswerExplanationChange(e, subIndex, index)}
                                                                            /> */}
                                                                            <CKEditor
                                                                                editor={ClassicEditor}
                                                                                data={sub_questions?.wrng_ans_exp}
                                                                                id={`wrongAnswerExplanation-${index}`}
                                                                                onReady={(editor) => console.log('Editor is ready to use!', editor)}
                                                                                onChange={(event, editor) =>
                                                                                    handleSubWrongAnswerExplanationChange(event, index, editor, subIndex)
                                                                                }
                                                                                onBlur={(event, editor) => console.log('Blur.', editor)}
                                                                                onFocus={(event, editor) => console.log('Focus.', editor)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className='row mb-3'>
                                                                    <div className='col-md-6'>
                                                                        {subIndex === marker.sub_questions?.length - 1 && (
                                                                            <button type="button" className='add_markers_button' onClick={(e) => handleSubAddMarkerForm(index, marker.sub_questions.length + 1)}>
                                                                                + Add Question
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                            {marker.question_type === 'rating' && <>
                                                <div className='col-md-12'>
                                                    <label htmlFor={`min-${index}`} className='col-sm-3 col-form-label'>
                                                        minimum value
                                                    </label>
                                                    <div className='col-sm-12'>
                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            id={`min-${index}`}
                                                            value={marker?.rating?.min}
                                                            onChange={(e) => handleminChange(e, index)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-md-12'>
                                                    <label htmlFor={`maximum-${index}`} className='col-sm-3 col-form-label'>
                                                        maximum value
                                                    </label>
                                                    <div className='col-sm-12'>
                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            id={`maximum-${index}`}
                                                            value={marker?.rating?.max}
                                                            onChange={(e) => handlemaxChange(e, index)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-md-12'>
                                                    <label htmlFor={`interval-${index}`} className='col-sm-3 col-form-label'>
                                                        Interval value
                                                    </label>
                                                    <div className='col-sm-12'>
                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            id={`interval-${index}`}
                                                            value={marker?.rating?.interval}
                                                            onChange={(e) => handleintervalChange(e, index)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-md-12'>
                                                    <label htmlFor={`Answer-${index}`} className='col-sm-3 col-form-label'>
                                                        Answer value
                                                    </label>
                                                    <div className='col-sm-12'>
                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            id={`Answer-${index}`}
                                                            value={marker?.rating?.ans}
                                                            onChange={(e) => handleansChange(e, index)}
                                                        />
                                                    </div>
                                                </div>
                                            </>}
                                            {(marker.question_type === 'single_choice' || marker.question_type === 'multi_choice') && <div className='row mb-3'>
                                                <div className='col-md-12'>
                                                    {marker.options.map((option, optionIndex) => (

                                                        <div className=''>
                                                            <p className='option-number pe-2 my-2'>Option {optionIndex + 1}</p>
                                                            <div key={optionIndex} className='form-check check-option'>
                                                                <div className='d-flex justify-content-end align-items-center pb-2'>  <img src="/images/delete.svg" onClick={() => handleRemoveOption(index, optionIndex)} /> </div>
                                                                <input
                                                                    className='form-check-input'
                                                                    type={marker.question_type === 'single_choice' ? 'radio' : 'checkbox'}
                                                                    value={option?.content}
                                                                    id={`option-${optionIndex}-${index}`}
                                                                    checked={option.is_correct || false}
                                                                    onChange={(e) => handleCheckboxChange(e, index)}
                                                                />
                                                                {/* <label className='form-check-label pl-20' htmlFor={`option-${optionIndex}-${index}`}> */}

                                                                <div style={{ paddingLeft: "20px" }}>
                                                                    <CKEditor
                                                                        editor={ClassicEditor}
                                                                        data={option?.content || ''}
                                                                        onReady={(editor) => {
                                                                            try {
                                                                                if (editor && editor.plugins) {
                                                                                    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                                                                                        // Initialize your custom upload adapter with a function to be called on file upload
                                                                                        return new MyUploadAdapter(loader, (e) => handleImageUpload(e, "O", index, optionIndex));
                                                                                    };
                                                                                }
                                                                            } catch (error) {
                                                                                handleEditorError(error);
                                                                            }
                                                                        }}
                                                                        // onReady={(editor) => console.log('Editor is ready to use!', editor)}
                                                                        onError={handleEditorError}
                                                                        onChange={(event, editor) => handleCKEditorChange(optionIndex, event, editor, index)}
                                                                        onBlur={(event, editor) => console.log('Blur.', editor)}
                                                                        onFocus={(event, editor) => console.log('Focus.', editor)}
                                                                    />
                                                                    {/* <button onClick={() => handleRemoveOption(index, optionIndex)}><img src="/images/delete.svg" /></button> */}

                                                                </div>

                                                                {/* </label> */}
                                                            </div>
                                                        </div>

                                                    ))}
                                                </div>
                                            </div>}

                                            {(marker.question_type === 'single_choice' || marker.question_type === 'multi_choice') && <div className='row mb-3'>
                                                <div className='col-md-6'>
                                                    <button className='btn btn-outline-secondary' type='button' onClick={() => handleAddOption(index)}>
                                                        + Add Option
                                                    </button>
                                                </div>

                                                {/* <div className='col-md-6'>
                                                      <div className='row'>
                                                          <label htmlFor={`correctAnswer-${index}`} className='col-sm-3 col-form-label'>
                                                              Correct Answer
                                                          </label>
                                                          <div className='col-sm-9'>
                                                              <select
                                                                  className='form-select'
                                                                  id={`correctAnswer-${index}`}
                                                                  value={marker.correctAnswer}
                                                                  // onChange={(e) => handleCorrectAnswerChange(e, index)}
                                                              >
                                                                  {marker.options.map((option, optionIndex) => (
                                                                      <option key={optionIndex}>{option?.content}</option>
                                                                  ))}
                                                              </select>
                                                          </div>
                                                      </div>
                                                  </div> */}
                                            </div>}

                                            {marker.question_type === 'para' ?
                                                <div className='row mb-3'>
                                                <div className='col-md-12 ssss'>
                                                    <label htmlFor={`correctAnswerExplanation-${index}`} className='col-sm-3 col-form-label'>
                                                        Common explanation
                                                    </label>
                                                    <div className='col-sm-12'>
                                                        <CKEditor
                                                            editor={ClassicEditor}
                                                            data={marker?.crt_ans_exp}
                                                            id={`correctAnswerExplanation-${index}`}
                                                            onReady={(editor) => console.log('Editor is ready to use!', editor)}
                                                            onChange={(event, editor) =>
                                                                handleCorrectAnswerExplanationChange(event, index, editor)
                                                            }
                                                            onBlur={(event, editor) => console.log('Blur.', editor)}
                                                            onFocus={(event, editor) => console.log('Focus.', editor)}
                                                        />
                                                    </div>
                                                </div>
                                            </div> : <>
                                                                                       <div className='row mb-3'>
                                                <div className='col-md-12 ssss'>
                                                    <label htmlFor={`correctAnswerExplanation-${index}`} className='col-sm-3 col-form-label'>
                                                        Correct answer explanation
                                                    </label>
                                                    <div className='col-sm-12'>
                                                        <CKEditor
                                                            editor={ClassicEditor}
                                                            data={marker?.crt_ans_exp}
                                                            id={`correctAnswerExplanation-${index}`}
                                                            onReady={(editor) => console.log('Editor is ready to use!', editor)}
                                                            onChange={(event, editor) =>
                                                                handleCorrectAnswerExplanationChange(event, index, editor)
                                                            }
                                                            onBlur={(event, editor) => console.log('Blur.', editor)}
                                                            onFocus={(event, editor) => console.log('Focus.', editor)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row mb-3'>
                                                <div className='col-md-12 ssss'>
                                                    <label htmlFor={`wrongAnswerExplanation-${index}`} className='col-sm-3 col-form-label'>
                                                        Wrong answer explanation
                                                    </label>
                                                    <div className='col-sm-12'>
                                                        <CKEditor
                                                            editor={ClassicEditor}
                                                            data={marker?.wrng_ans_exp}
                                                            id={`wrongAnswerExplanation-${index}`}
                                                            onReady={(editor) => console.log('Editor is ready to use!', editor)}
                                                            onChange={(event, editor) =>
                                                                handleWrongAnswerExplanationChange(event, index, editor)
                                                            }
                                                            onBlur={(event, editor) => console.log('Blur.', editor)}
                                                            onFocus={(event, editor) => console.log('Focus.', editor)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            </>
                                            }

                                            <div className='row mb-3'>
                                                <div className='col-md-6'>
                                                    {index === markerForms.length - 1 && (
                                                        <button className='add_markers_button' onClick={() => handleAddMarkerForm(markerForms.length + 1)}>
                                                            Add Question
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div> : null}
                </form>
                <div className='course_component'>
                    <div className='d-flex mb-0'>
                        <div className='course_content_menu col' onClick={() => { setSelectedContentType('content'); reset() }}>
                            <img src="/images/font.png" className='mb-1 content_icon'></img>
                            <p className='mb-0'>Add Text</p>
                        </div>
                        <div className='course_content_menu col' onClick={() => { setSelectedContentType('carousal'); reset() }}>
                            <img src="/images/add-image.png" className='mb-1 content_icon'></img>
                            <p className='mb-0'>Add Carousal</p>
                        </div>
                        <div className='course_content_menu col' onClick={() => { setSelectedContentType('video'); reset() }}>
                            <img src="/images/video-player.png" className='mb-1 content_icon'></img>
                            <p className='mb-0'>Add Video</p>
                        </div>
                        <div className='course_content_menu col' onClick={() => { setSelectedContentType('test'); reset() }}>
                            <img src="/images/idea.png" className='mb-1 content_icon'></img>
                            <p className='mb-0'>Test</p>
                        </div>
                        <div className='course_content_menu col' onClick={() => { setSelectedContentType('document'); reset() }}>
                            <img src="/images/add-document.png" className='mb-1 content_icon'></img>
                            <p className='mb-0'>Document</p>
                        </div>
                        <div className='course_content_menu col'>
                            <img src="/images/share.png" className='mb-1 content_icon'></img>
                            <p className='mb-0'>Snippet</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CourseContent;
